<template>
  <div id="admit-data-div">
    <!-- <b-alert show variant="danger" class="margin-bottom font12px icon-dark-custom"  > -->
    <b-card
      bg-variant="danger"
      text-variant="white"
      class="text-left margin-bottom font-color-print"
    >
      <b-row>
        <b-col lg="3">
          {{ vnChang }}
          <h5>AN : {{ this.ptAdmitData && this.ptAdmitData.datas.an }}</h5>
        </b-col>
        <b-col lg="3">
          <h5>HN : {{ this.ptData && this.ptData.datas.hn }}</h5>
        </b-col>
        <b-col>
          <h5>
            ชื่อ-สกุล
            {{
              this.ptData &&
                this.ptData.datas.pname +
                  this.ptData.datas.fname +
                  "  " +
                  this.ptData.datas.lname
            }}
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3">
          <h5>CID : {{ this.ptAdmitData && this.ptAdmitData.datas.cid }}</h5>
        </b-col>
        <b-col lg="3">
          <h6>
            วันที่รับ :
            {{
              this.ptAdmitData &&
                this.thaiDatetimeFc.ThaiDateTime(
                  this.ptAdmitData.datas.regdate +
                    " " +
                    this.ptAdmitData.datas.regtime
                )
            }}
          </h6>
        </b-col>
        <b-col>
          <h6>
            วันที่จำหน่วย :
            {{
              this.ptAdmitData &&
                this.thaiDatetimeFc.ThaiDateTime(
                  this.ptAdmitData.datas.dchdate +
                    " " +
                    this.ptAdmitData.datas.dchtime
                )
            }}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6 class="font-color-warning2 font-color-print">
            อาการสำคัญ :
            {{ this.ptAdmitData && this.ptAdmitData.datas.prediag }}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4">
          <h6>
            แพทย์เจ้าของไข้ :
            {{
              this.ptAdmitData && this.ptAdmitData.datas.incharge_doctor_name
            }}
          </h6>
        </b-col>
        <b-col lg="4">
          <h6>
            Ward : {{ this.ptAdmitData && this.ptAdmitData.datas.ward_name }}
          </h6>
        </b-col>
        <b-col>
          <h6>
            แผนก : {{ this.ptAdmitData && this.ptAdmitData.datas.spclty_name }}
          </h6>
        </b-col>
      </b-row>

      <b-row v-if="this.ptData && this.ptData.datas.clinic">
        <b-col>
          <h5 class="font-color-warning2 font-color-print">
            โรคประจำตัว : {{ this.ptData && this.ptData.datas.clinic }}
          </h5>
        </b-col>
      </b-row>

      <b-row v-if="this.ptData && this.ptData.datas.drugallergy">
        <b-col>
          <h5 class="font-color-warning2 font-color-print">
            แพ้ยา : {{ this.ptData && this.ptData.datas.drugallergy }}
          </h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h6>
            สิทธิประจำตัว :
            {{
              this.ptData &&
                this.pjFunctionsFc.NulltoStr(this.ptData.datas.pttype) +
                  " " +
                  this.pjFunctionsFc.NulltoStr(this.ptData.datas.pttype_name)
            }}
          </h6>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            variant="info"
            size="sm"
            class="d-print-none"
            @click="viewEMR(ptHN)"
            v-show="false"
            >ดูประวัติการรักษา (EMR)</b-button
          >

          <b-img
            thumbnail
            rounded="circle"
            alt="ดูประวัติการรักษา (EMR)"
            title="ดูประวัติการรักษา (EMR)"
            width="50"
            class="icon-css cursor-pointer margin-right8px"
            style="background-color:#ffffff;padding:2px;"
            v-bind:src="imgEMRIcon"
            @click="viewEMR(ptHN)"
          ></b-img>
        </b-col>
      </b-row>
    </b-card>

   
      <EmrDocumentScanIPD
              v-bind:my-hn="this.ptHN"
              v-bind:my-an="this.ptAN"
              v-if="this.DocumentScanIPDLoadSTD"
    ></EmrDocumentScanIPD>
  

    

    <b-alert show class="text-left margin-bottom" variant="dark">
      <h5>
        Discharge Summary :
        <b-button
          variant="success"
          size="sm"
          class="d-print-none"
          @click="
            selectDataDCH(
              ptVN,
              ptHN,
              ptAN,
              $store.get('systems@LoginData').UserId
            )
          "
          >บันทึก Discharge Summary</b-button
        >

        <b-button
          variant="primary"
          size="sm"
          class="d-print-none margin-left4px"
          @click="selectCodingAuditDataDCH(ptVN, ptHN, ptAN, 'CodingAudit')"
          v-if="this.coding_audit_data_status"
          >Coding Audit</b-button
        >

        <b-button
          variant="secondary"
          size="sm"
          class="d-print-none margin-left4px"
          @click="selectCodingAuditDataDCH(ptVN, ptHN, ptAN, 'CodingAudit')"
          v-if="!this.coding_audit_data_status"
          >Coding Audit</b-button
        >
      </h5>

      <b-row>
        <b-col
          lg="4"
          class="margin-bottom"
          v-for="item in this.ptAdmitDischargeSummary"
          v-bind:key="item.id"
        >
          <b-button
            size="sm"
            :variant="
              ($store.get('systems@LoginData').UserId == item.loginname &&
                'warning') ||
                'info'
            "
            @click="
              $root.$emit(
                'bv::toggle::collapse',
                'modal-admit-discharge-summary' + item.loginname
              )
            "
            v-if="$store.get('systems@LoginData').UserId != item.loginname"
          >
            {{
              item.datas.doctor_name +
                " L." +
                thaiDatetimeFc.ThaiDateTime(
                  item.datas.discharge_summary_datetime_log
                )
            }}
          </b-button>

          <!-- 
              <b-button size="sm" :variant=" ($store.get('systems@LoginData').UserId == item.loginname) && 'warning' || 'info' " @click="selectDataDCH(ptVN,ptHN,ptAN,item.loginname)" v-if="($store.get('systems@LoginData').UserId != item.loginname && ModulRightCheck)"  >
                {{ item.datas.doctor_name+' L.'+thaiDatetimeFc.ThaiDateTime(item.datas.discharge_summary_datetime_log) }}
              </b-button> -->

          <b-button
            size="sm"
            :variant="
              ($store.get('systems@LoginData').UserId == item.loginname &&
                'warning') ||
                'info'
            "
            @click="selectDataDCH(ptVN, ptHN, ptAN, item.loginname)"
            v-if="$store.get('systems@LoginData').UserId == item.loginname"
          >
            {{
              item.datas.doctor_name +
                " L." +
                thaiDatetimeFc.ThaiDateTime(
                  item.datas.discharge_summary_datetime_log
                )
            }}
          </b-button>
        </b-col>
      </b-row>

      <div>
        <div v-for="item in this.ptAdmitDischargeSummary" v-bind:key="item.id">
          <b-collapse
            :id="'modal-admit-discharge-summary' + item.loginname"
            title="Discharge Summary"
            size="xl"
            v-if="$store.get('systems@LoginData').UserId != item.loginname"
            :no-close-on-backdrop="true"
            :close-on-esc="true"
            accordion="AdmitDischargeSummary-accordion"
          >
            <b-card
              bg-variant="secondary"
              class="text-left font-color-black margin-bottom"
            >
              <b-alert show class="margin-bottom alert-dark">
                <h6>แพทย์ผู้บันทึก : {{ item.datas.doctor_name }}</h6>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-primary-piagnosis' + item.loginname">
                  <b-badge href="#" variant="primary"
                    >Primary Diagnosis :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-primary-piagnosis' + item.loginname"
                  :visible="item.datas.doctor_primary_diagnosis != ''"
                >
                  <b-form-textarea
                    :id="'primary-piagnosis' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_primary_diagnosis"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-comorbidity' + item.loginname">
                  <b-badge href="#" variant="primary">Comorbidity :</b-badge>
                </h5>

                <b-collapse
                  :id="'collapse-comorbidity' + item.loginname"
                  :visible="item.datas.doctor_comorbidity != ''"
                >
                  <b-form-textarea
                    :id="'comorbidity' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_comorbidity"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-complication' + item.loginname">
                  <b-badge href="#" variant="primary">Complication :</b-badge>
                </h5>

                <b-collapse
                  :id="'collapse-complication' + item.loginname"
                  :visible="item.datas.doctor_complication != ''"
                >
                  <b-form-textarea
                    :id="'complication' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_complication"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-others-diag' + item.loginname">
                  <b-badge href="#" variant="primary">Others Diag :</b-badge>
                </h5>

                <b-collapse
                  :id="'collapse-others-diag' + item.loginname"
                  :visible="item.datas.doctor_others_diag != ''"
                >
                  <b-form-textarea
                    :id="'others-diag' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_others_diag"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5
                  v-b-toggle="'collapse-course-progressnote' + item.loginname"
                >
                  <b-badge href="#" variant="primary"
                    >Hospital Course / Progress Note :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-course-progressnote' + item.loginname"
                  :visible="item.datas.doctor_course_progressnote != ''"
                >
                  <b-form-textarea
                    :id="'course-progressnote' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_course_progressnote"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-anesthetic-note' + item.loginname">
                  <b-badge href="#" variant="primary"
                    >Anesthetic Note :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-anesthetic-note' + item.loginname"
                  :visible="item.datas.doctor_anesthetic_note != ''"
                >
                  <b-form-textarea
                    :id="'course-anesthetic-note' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_anesthetic_note"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5
                  v-b-toggle="'collapse-operation-procedure' + item.loginname"
                >
                  <b-badge href="#" variant="primary"
                    >Operation / Procedure :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-operation-procedure' + item.loginname"
                  :visible="item.datas.doctor_operation_procedure != ''"
                >
                  <b-form-textarea
                    :id="'course-operation-procedure' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_operation_procedure"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-operation-findings' + item.loginname">
                  <b-badge href="#" variant="primary"
                    >Operation Findings :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-operation-findings' + item.loginname"
                  :visible="item.datas.doctor_operation_findings != ''"
                >
                  <b-form-textarea
                    :id="'course-operation-findings' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_operation_findings"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5>
                  <b-badge href="#" variant="primary"
                    >Operative Note Image :</b-badge
                  >
                </h5>

                <b-row>
                  <b-col
                    class="margin-bottom"
                    cols="3"
                    v-for="(item,
                    index) in pjFunctionsFc.IPDListDataArrayfilter(
                      IPDImageListData,
                      item.loginname
                    )"
                    v-bind:key="item.id"
                  >
                    <b-modal
                      :id="'modal-ipd-image-view' + index"
                      title="IPD Operative Note Images"
                      size="xl"
                      hide-footer
                    >
                      <div class="text-align-center log-style">
                        File Name : {{ item.datas.file_name_old }}
                      </div>
                      <div class="text-align-center log-style">
                        User log : {{ item.datas.file_user_name_log }}
                      </div>
                      <div class="text-align-center log-style">
                        DateTime : {{ item.datas.file_datetime }}
                      </div>
                      <div class="text-align-center margin-bottom">
                        <b-img
                          rounded
                          class="image_physical_show"
                          :src="'data:image;base64,' + item.datas.file_base64"
                          v-if="item"
                          :alt="
                            item.datas.file_name_old +
                              '\nLog.' +
                              item.datas.file_user_name_log +
                              ' | ' +
                              item.datas.file_datetime
                          "
                          :title="
                            item.datas.file_name_old +
                              '\nLog.' +
                              item.datas.file_user_name_log +
                              ' | ' +
                              item.datas.file_datetime
                          "
                        ></b-img>
                      </div>

                      <div class="d-block text-center">
                        <b-button
                          variant="info"
                          size="sm"
                          class="d-print-none"
                          v-print="'#modal-ipd-image-view' + index"
                        >
                          Print
                        </b-button>
                        &nbsp;
                        <b-button
                          size="sm"
                          class="d-print-none"
                          @click="$bvModal.hide('modal-ipd-image-view' + index)"
                          >Close</b-button
                        >
                      </div>
                    </b-modal>

                    <b-img
                      class="img-preview-ipfs cursor-pointer"
                      center
                      :src="'data:image;base64,' + item.datas.file_base64"
                      :alt="
                        item.datas.file_name_old +
                          '\nLog.' +
                          item.datas.file_user_name_log +
                          ' | ' +
                          item.datas.file_datetime
                      "
                      :title="
                        item.datas.file_name_old +
                          '\nLog.' +
                          item.datas.file_user_name_log +
                          ' | ' +
                          item.datas.file_datetime
                      "
                      v-b-modal="'modal-ipd-image-view' + index"
                    ></b-img>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    class="margin-bottom"
                    cols="3"
                    v-for="(item,
                    index) in pjFunctionsFc.IpfsListDataArrayfilter(
                      IpfsListData,
                      item.loginname
                    )"
                    v-bind:key="item.id"
                  >
                    <b-modal
                      :id="'modal-ipfs-ipd-image-view' + index"
                      title="IPD Operative Note Images on IPFS"
                      size="xl"
                      hide-footer
                    >
                      <div class="text-align-center log-style">
                        File Name : {{ item.file_name }}
                      </div>
                      <div class="text-align-center log-style">
                        User log : {{ item.ipfs_file_user }}
                      </div>
                      <div class="text-align-center log-style">
                        DateTime : {{ item.datas.ipfs_file_datetime }}
                      </div>
                      <div class="text-align-center margin-bottom">
                        <b-img
                          rounded
                          class="image_physical_show"
                          :src="'data:image;base64,' + item.files_base64"
                          v-if="item"
                          :alt="
                            item.file_name +
                              '\nLog.' +
                              item.ipfs_file_user +
                              ' | ' +
                              item.ipfs_file_datetime
                          "
                          :title="
                            item.file_name +
                              '\nLog.' +
                              item.ipfs_file_user +
                              ' | ' +
                              item.ipfs_file_datetime
                          "
                        ></b-img>
                      </div>

                      <div class="d-block text-center">
                        <b-button
                          variant="info"
                          size="sm"
                          class="d-print-none"
                          v-print="'#modal-ipfs-ipd-image-view' + index"
                        >
                          Print
                        </b-button>
                        &nbsp;
                        <b-button
                          size="sm"
                          class="d-print-none"
                          @click="
                            $bvModal.hide('modal-ipfs-ipd-image-view' + index)
                          "
                          >Close</b-button
                        >
                      </div>
                    </b-modal>

                    <b-img
                      class="img-preview-ipfs cursor-pointer"
                      center
                      :src="'data:image;base64,' + item.files_base64"
                      :alt="
                        item.file_name +
                          '\nLog.' +
                          item.datas.ipfs_file_user +
                          ' | ' +
                          item.datas.ipfs_file_datetime
                      "
                      :title="
                        item.file_name +
                          '\nLog.' +
                          item.datas.ipfs_file_user +
                          ' | ' +
                          item.datas.ipfs_file_datetime
                      "
                      v-b-modal="'modal-ipfs-ipd-image-view' + index"
                    ></b-img>
                  </b-col>
                </b-row>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5 v-b-toggle="'collapse-doctor-note' + item.loginname">
                  <b-badge href="#" variant="primary"
                    >Doctor Note / Plan of treatment :</b-badge
                  >
                </h5>

                <b-collapse
                  :id="'collapse-doctor-note' + item.loginname"
                  :visible="item.datas.doctor_note != ''"
                >
                  <b-form-textarea
                    :id="'course-doctor-note' + item.loginname"
                    rows="3"
                    max-rows="7"
                    readonly
                    :value="item.datas.doctor_note"
                  >
                  </b-form-textarea>
                </b-collapse>
              </b-alert>

              <b-alert show class="margin-bottom alert-dark">
                <h5>
                  <b-badge variant="primary">Doctor Discharge :</b-badge>
                </h5>

                <b-row>
                  <b-col lg="6">
                    <h6>Discharge Status :</h6>
                    <b-form-input
                      :value="item.datas.doctor_dchstts_name"
                      readonly
                    ></b-form-input>
                  </b-col>
                  <b-col lg="6" v-if="ptAdmitDischargeType">
                    <h6>Discharge Type :</h6>
                    <b-form-input
                      :value="item.datas.doctor_dchtype_name"
                      readonly
                    ></b-form-input>
                    <h6>Other / By Transfer :</h6>
                    <b-form-input
                      :value="item.datas.doctor_dchtype_text"
                      readonly
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-alert>

              <div class="log-style">
                Log. {{ item.datas.discharge_summary_user_log }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.discharge_summary_datetime_log
                  )
                }}
              </div>
            </b-card>

            <template>
              <b-row>
                <b-col cols="3"> </b-col>
                <b-col cols="6" class="text-align-center">
                  <b-button
                    size="sm"
                    class="margin-left4px"
                    variant="warning"
                    @click="
                      $root.$emit(
                        'bv::toggle::collapse',
                        'modal-admit-discharge-summary' + item.loginname
                      )
                    "
                  >
                    ย่อหน้าต่าง
                  </b-button>
                </b-col>
                <b-col cols="3"> </b-col>
              </b-row>
            </template>
          </b-collapse>
        </div>
      </div>

      <div>
        <b-collapse
          class="my-modal"
          :id="
            'modal-admit-discharge-summary-coding-audit-ed-' +
              SelectCodingAuditdchUser
          "
          title="Discharge Summary"
          size="xl"
          button-size="sm"
          v-if="
            $store.get('systems@LoginData').UserId != '' &&
              SelectCodingAuditdchUser != ''
          "
          :no-close-on-backdrop="true"
          :close-on-esc="true"
          accordion="AdmitDischargeSummary-accordion"
        >
          <b-card
            bg-variant="secondary"
            class="text-left font-color-black margin-bottom"
          >
            <b-alert show class="margin-bottom alert-dark">
              <h6>ผู้บันทึก : {{ SelectCodingAuditdchUser }}</h6>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-primary-diagnosis' + SelectCodingAuditdchUser
                "
              >
                <b-badge href="#" variant="primary"
                  >Primary Diagnosis :</b-badge
                >
              </h5>

              <b-collapse
                :id="'collapse-primary-diagnosis' + SelectCodingAuditdchUser"
                :visible="coding_audit_primary_diagnosis != ''"
              >
                <b-form-textarea
                  :id="'primary-diagnosis' + SelectCodingAuditdchUser"
                  placeholder="Primary Diagnosis"
                  :value="coding_audit_primary_diagnosis"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="'collapse-comorbidity' + SelectCodingAuditdchUser"
              >
                <b-badge href="#" variant="primary">Comorbidity :</b-badge>
              </h5>

              <b-collapse
                :id="'collapse-comorbidity' + SelectCodingAuditdchUser"
                :visible="coding_audit_comorbidity != ''"
              >
                <b-form-textarea
                  :id="'comorbidity' + SelectCodingAuditdchUser"
                  placeholder="Comorbidity"
                  :value="coding_audit_comorbidity"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="'collapse-complication' + SelectCodingAuditdchUser"
              >
                <b-badge href="#" variant="primary">Complication :</b-badge>
              </h5>

              <b-collapse
                :id="'collapse-complication' + SelectCodingAuditdchUser"
                :visible="coding_audit_complication != ''"
              >
                <b-form-textarea
                  :id="'complication' + SelectCodingAuditdchUser"
                  placeholder="complication"
                  :value="coding_audit_complication"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="'collapse-others-diag' + SelectCodingAuditdchUser"
              >
                <b-badge href="#" variant="primary">Others Diag :</b-badge>
              </h5>

              <b-collapse
                :id="'collapse-others-diag' + SelectCodingAuditdchUser"
                :visible="coding_audit_others_diag != ''"
              >
                <b-form-textarea
                  :id="'others-diag' + SelectCodingAuditdchUser"
                  placeholder="Others Diag"
                  :value="coding_audit_others_diag"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-course-progressnote' + SelectCodingAuditdchUser
                "
              >
                <b-badge href="#" variant="primary"
                  >Hospital Course / Progress Note :</b-badge
                >
              </h5>

              <b-collapse
                :id="'collapse-course-progressnote' + SelectCodingAuditdchUser"
                :visible="coding_audit_course_progressnote != ''"
              >
                <b-form-textarea
                  :id="'course-progressnote' + SelectCodingAuditdchUser"
                  placeholder="Hospital Course / Progress Note"
                  :value="coding_audit_course_progressnote"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-anesthetic-note' + SelectCodingAuditdchUser
                "
              >
                <b-badge href="#" variant="primary">Anesthetic Note :</b-badge>
              </h5>

              <b-collapse
                :id="'collapse-anesthetic-note' + SelectCodingAuditdchUser"
                :visible="coding_audit_anesthetic_note != ''"
              >
                <b-form-textarea
                  :id="'course-anesthetic-note' + SelectCodingAuditdchUser"
                  placeholder="Anesthetic Note"
                  :value="coding_audit_anesthetic_note"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-operation-procedure' + SelectCodingAuditdchUser
                "
              >
                <b-badge href="#" variant="primary"
                  >Operation / Procedure :</b-badge
                >
              </h5>

              <b-collapse
                :id="'collapse-operation-procedure' + SelectCodingAuditdchUser"
                :visible="coding_audit_operation_procedure != ''"
              >
                <b-form-textarea
                  :id="'course-operation-procedure' + SelectCodingAuditdchUser"
                  placeholder="Operation / Procedure"
                  :value="coding_audit_operation_procedure"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-operation-findings' + SelectCodingAuditdchUser
                "
              >
                <b-badge href="#" variant="primary"
                  >Operation Findings :</b-badge
                >
              </h5>

              <b-collapse
                :id="'collapse-operation-findings' + SelectCodingAuditdchUser"
                :visible="coding_audit_operation_findings != ''"
              >
                <b-form-textarea
                  :id="'course-operation-findings' + SelectCodingAuditdchUser"
                  placeholder="Operation Findings"
                  :value="coding_audit_operation_findings"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="'collapse-doctor-note' + SelectCodingAuditdchUser"
              >
                <b-badge href="#" variant="primary"
                  >Doctor Note / Plan of treatment :</b-badge
                >
              </h5>

              <b-collapse
                :id="'collapse-doctor-note' + SelectCodingAuditdchUser"
                :visible="coding_audit_doctor_note != ''"
              >
                <b-form-textarea
                  :id="'course-doctor-note' + SelectCodingAuditdchUser"
                  placeholder="Doctor Note / Plan of treatment"
                  :value="coding_audit_doctor_note"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5>
                <b-badge variant="primary">Doctor Discharge :</b-badge>
              </h5>
              <b-row>
                <b-col lg="6">
                  <h6>Discharge Status :</h6>
                  <b-form-select
                    v-model="CodingAuditptAdmitDischargeStatusSelect"
                    :options="ptAdmitDischargeStatus"
                  ></b-form-select>
                </b-col>

                <b-col lg="6" v-if="ptAdmitDischargeType">
                  <h6>Discharge Type :</h6>
                  <b-form-select
                    v-model="CodingAuditptAdmitDischargeTypeSelect"
                    :options="ptAdmitDischargeType"
                  ></b-form-select>
                  <h6>Other / By Transfer :</h6>
                  <b-form-input
                    :id="'dchtype-text' + SelectCodingAuditdchUser"
                    :value="coding_audit_dchtype_text"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-alert>
            <div class="log-style" v-if="CodingAuditUserAdmitDischargeSummary">
              Log.
              {{
                CodingAuditUserAdmitDischargeSummary.datas
                  .discharge_summary_user_log
              }}
              |
              {{
                thaiDatetimeFc.ThaiDateTime(
                  CodingAuditUserAdmitDischargeSummary.datas
                    .discharge_summary_datetime_log
                )
              }}
            </div>
          </b-card>

          <template v-if="ModulRightCheck">
            <b-row>
              <b-col cols="3"> </b-col>
              <b-col cols="6" class="text-align-center">
                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="success"
                  @click="
                    CodingAuditSubmitCheckData(
                      ptAN,
                      'AddDischargeSummaryCodingAudit',
                      'ยืนยันการบันทึกข้อมูล'
                    )
                  "
                >
                  บันทึก
                </b-button>

                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="secondary"
                  @click="
                    closeDischargeSummaryCodingAudit(SelectCodingAuditdchUser)
                  "
                >
                  ยกเลิก
                </b-button>
              </b-col>
              <b-col cols="3">
                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="danger"
                  @click="
                    CodingAuditSubmitCheckData(
                      ptAN,
                      'DeleteDischargeSummaryCodingAudit',
                      'ยืนยันการลบข้อมูล'
                    )
                  "
                >
                  ลบ
                </b-button>
              </b-col>
            </b-row>
          </template>

          <template v-if="!ModulRightCheck">
            <b-row>
              <b-col cols="3"> </b-col>
              <b-col cols="6" class="text-align-center">
                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="warning"
                  @click="
                    closeDischargeSummaryCodingAudit(SelectCodingAuditdchUser)
                  "
                >
                  ย่อหน้าต่าง
                </b-button>
              </b-col>
              <b-col cols="3"> </b-col>
            </b-row>
          </template>
        </b-collapse>
      </div>

      <div>
        <b-collapse
          class="my-modal"
          :id="'modal-admit-discharge-summary-ed-' + SelectdchUser"
          title="Discharge Summary"
          size="xl"
          button-size="sm"
          v-if="
            $store.get('systems@LoginData').UserId != '' && SelectdchUser != ''
          "
          :no-close-on-backdrop="true"
          :close-on-esc="true"
          accordion="AdmitDischargeSummary-accordion"
        >
          <b-card
            bg-variant="secondary"
            class="text-left font-color-black margin-bottom"
          >
            <b-alert show class="margin-bottom alert-dark">
              <h6>
                แพทย์ผู้บันทึก :
                {{
                  UserAdmitDischargeSummary &&
                    UserAdmitDischargeSummary.datas.doctor_name
                }}
              </h6>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-primary-diagnosis' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary"
                  >Primary Diagnosis :</b-badge
                >
              </h5>

              <b-collapse
                :id="
                  'collapse-primary-diagnosis' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="primary_diagnosis != ''"
              >
                <b-form-textarea
                  :id="
                    'primary-diagnosis' + $store.get('systems@LoginData').UserId
                  "
                  placeholder="Primary Diagnosis"
                  :value="primary_diagnosis"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-comorbidity' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary">Comorbidity :</b-badge>
              </h5>

              <b-collapse
                :id="
                  'collapse-comorbidity' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="comorbidity != ''"
              >
                <b-form-textarea
                  :id="'comorbidity' + $store.get('systems@LoginData').UserId"
                  placeholder="Comorbidity"
                  :value="comorbidity"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-complication' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary">Complication :</b-badge>
              </h5>

              <b-collapse
                :id="
                  'collapse-complication' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="complication != ''"
              >
                <b-form-textarea
                  :id="'complication' + $store.get('systems@LoginData').UserId"
                  placeholder="complication"
                  :value="complication"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-others-diag' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary">Others Diag :</b-badge>
              </h5>

              <b-collapse
                :id="
                  'collapse-others-diag' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="others_diag != ''"
              >
                <b-form-textarea
                  :id="'others-diag' + $store.get('systems@LoginData').UserId"
                  placeholder="Others Diag"
                  :value="others_diag"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-course-progressnote' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary"
                  >Hospital Course / Progress Note :</b-badge
                >
              </h5>

              <b-collapse
                :id="
                  'collapse-course-progressnote' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="course_progressnote != ''"
              >
                <b-form-textarea
                  :id="
                    'course-progressnote' +
                      $store.get('systems@LoginData').UserId
                  "
                  placeholder="Hospital Course / Progress Note"
                  :value="course_progressnote"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-anesthetic-note' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary">Anesthetic Note :</b-badge>
              </h5>

              <b-collapse
                :id="
                  'collapse-anesthetic-note' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="anesthetic_note != ''"
              >
                <b-form-textarea
                  :id="
                    'course-anesthetic-note' +
                      $store.get('systems@LoginData').UserId
                  "
                  placeholder="Anesthetic Note"
                  :value="anesthetic_note"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-operation-procedure' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary"
                  >Operation / Procedure :</b-badge
                >
              </h5>

              <b-collapse
                :id="
                  'collapse-operation-procedure' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="operation_procedure != ''"
              >
                <b-form-textarea
                  :id="
                    'course-operation-procedure' +
                      $store.get('systems@LoginData').UserId
                  "
                  placeholder="Operation / Procedure"
                  :value="operation_procedure"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-operation-findings' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary"
                  >Operation Findings :</b-badge
                >
              </h5>

              <b-collapse
                :id="
                  'collapse-operation-findings' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="operation_findings != ''"
              >
                <b-form-textarea
                  :id="
                    'course-operation-findings' +
                      $store.get('systems@LoginData').UserId
                  "
                  placeholder="Operation Findings"
                  :value="operation_findings"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5>
                <b-badge href="#" variant="primary"
                  >Operative Note Image :</b-badge
                >
              </h5>

              <b-row>
                <b-col
                  class="margin-bottom"
                  cols="3"
                  v-for="(item, index) in pjFunctionsFc.IPDListDataArrayfilter(
                    IPDImageListData,
                    $store.get('systems@LoginData').UserId
                  )"
                  v-bind:key="item.id"
                >
                  <b-modal
                    :id="'modal-ipd-image' + index"
                    title="IPD Operative Note Images"
                    size="xl"
                    hide-footer
                  >
                    <div class="text-align-center log-style">
                      File Name : {{ item.datas.file_name_old }}
                    </div>
                    <div class="text-align-center log-style">
                      User log : {{ item.datas.file_user_name_log }}
                    </div>
                    <div class="text-align-center log-style">
                      DateTime : {{ item.datas.file_datetime }}
                    </div>
                    <div class="text-align-center margin-bottom">
                      <b-img
                        rounded
                        class="image_physical_show"
                        :src="'data:image;base64,' + item.datas.file_base64"
                        v-if="item"
                        :alt="
                          item.datas.file_name_old +
                            '\nLog.' +
                            item.datas.file_user_name_log +
                            ' | ' +
                            item.datas.file_datetime
                        "
                        :title="
                          item.datas.file_name_old +
                            '\nLog.' +
                            item.datas.file_user_name_log +
                            ' | ' +
                            item.datas.file_datetime
                        "
                      ></b-img>
                    </div>

                    <div class="d-block text-center">
                      <b-button
                        variant="info"
                        size="sm"
                        class="d-print-none"
                        v-print="'#modal-ipd-image' + index"
                      >
                        Print
                      </b-button>
                      &nbsp;
                      <b-button
                        size="sm"
                        class="d-print-none"
                        @click="$bvModal.hide('modal-ipd-image' + index)"
                        >Close</b-button
                      >
                    </div>
                  </b-modal>

                  <b-img
                    class="img-preview-ipfs cursor-pointer"
                    center
                    :src="'data:image;base64,' + item.datas.file_base64"
                    :alt="
                      item.datas.file_name_old +
                        '\nLog.' +
                        item.datas.file_user_name_log +
                        ' | ' +
                        item.datas.file_datetime
                    "
                    :title="
                      item.datas.file_name_old +
                        '\nLog.' +
                        item.datas.file_user_name_log +
                        ' | ' +
                        item.datas.file_datetime
                    "
                    v-b-modal="'modal-ipd-image' + index"
                  ></b-img>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                  class="margin-bottom"
                  cols="3"
                  v-for="(item, index) in pjFunctionsFc.IpfsListDataArrayfilter(
                    IpfsListData,
                    $store.get('systems@LoginData').UserId
                  )"
                  v-bind:key="item.id"
                >
                  <b-modal
                    :id="'modal-ipfs-ipd-image' + index"
                    title="IPD Operative Note Images on IPFS"
                    size="xl"
                    hide-footer
                  >
                    <div class="text-align-center log-style">
                      File Name : {{ item.file_name }}
                    </div>
                    <div class="text-align-center log-style">
                      User log : {{ item.ipfs_file_user }}
                    </div>
                    <div class="text-align-center log-style">
                      DateTime : {{ item.datas.ipfs_file_datetime }}
                    </div>
                    <div class="text-align-center margin-bottom">
                      <b-img
                        rounded
                        class="image_physical_show"
                        :src="'data:image;base64,' + item.files_base64"
                        v-if="item"
                        :alt="
                          item.file_name +
                            '\nLog.' +
                            item.ipfs_file_user +
                            ' | ' +
                            item.ipfs_file_datetime
                        "
                        :title="
                          item.file_name +
                            '\nLog.' +
                            item.ipfs_file_user +
                            ' | ' +
                            item.ipfs_file_datetime
                        "
                      ></b-img>
                    </div>

                    <div class="d-block text-center">
                      <b-button
                        variant="info"
                        size="sm"
                        class="d-print-none"
                        v-print="'#modal-ipfs-ipd-image' + index"
                      >
                        Print
                      </b-button>
                      &nbsp;
                      <b-button
                        size="sm"
                        class="d-print-none"
                        @click="$bvModal.hide('modal-ipfs-ipd-image' + index)"
                        >Close</b-button
                      >
                      &nbsp;
                      <b-button
                        v-if="
                          item.ipfs_file_user ==
                            $store.get('systems@LoginData').UserId
                        "
                        variant="danger"
                        size="sm"
                        class="float-right d-print-none"
                        @click="IPFSIPDImageDel(item.datas.ipfs_file_hash)"
                        >ลบ</b-button
                      >
                    </div>
                  </b-modal>

                  <b-img
                    class="img-preview-ipfs cursor-pointer"
                    center
                    :src="'data:image;base64,' + item.files_base64"
                    :alt="
                      item.ipfs_file_name +
                        '\nLog.' +
                        item.ipfs_file_user +
                        ' | ' +
                        item.ipfs_file_datetime
                    "
                    :title="
                      item.ipfs_file_name +
                        '\nLog.' +
                        item.ipfs_file_user +
                        ' | ' +
                        item.ipfs_file_datetime
                    "
                    v-b-modal="'modal-ipfs-ipd-image' + index"
                  ></b-img>
                </b-col>
              </b-row>

              <div
                class="my-8"
                v-if="this.$store.get('systems@IPFS_USE') == 'Y'"
              >
                <image-uploader
                  id="emr-ipd-operative-note"
                  :debug="0"
                  :quality="0.9"
                  :autoRotate="true"
                  :maxWidth="1024"
                  :maxHeight="1024"
                  outputFormat="file"
                  :preview="false"
                  :className="[
                    'emr-ipd-operative-note',
                    { 'fileinput--loaded': hasImage }
                  ]"
                  :capture="false"
                  accept="image/jpeg, image/png"
                  doNotResize="['gif', 'svg']"
                  @input="setImage"
                  @onComplete="endImageResize"
                >
                  <label
                    for="emr-ipd-operative-note"
                    slot="upload-label"
                    style="width:100%;margin-bottom:0px;margin-top:4px;"
                  >
                    <figure style="margin-bottom: 0px">
                      <!-- 
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 32 32"
                          >
                            <path
                              class="path1"
                              d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                            />
                          </svg> -->

                      <v-icon
                        name="camera"
                        class="icon-camera-custom font-color-link2 cursor-pointer"
                      ></v-icon>
                    </figure>
                  </label>
                </image-uploader>
              </div>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5
                v-b-toggle="
                  'collapse-doctor-note' +
                    $store.get('systems@LoginData').UserId
                "
              >
                <b-badge href="#" variant="primary"
                  >Doctor Note / Plan of treatment :</b-badge
                >
              </h5>

              <b-collapse
                :id="
                  'collapse-doctor-note' +
                    $store.get('systems@LoginData').UserId
                "
                :visible="doctor_note != ''"
              >
                <b-form-textarea
                  :id="
                    'course-doctor-note' +
                      $store.get('systems@LoginData').UserId
                  "
                  placeholder="Doctor Note / Plan of treatment"
                  :value="doctor_note"
                  rows="3"
                  max-rows="7"
                >
                </b-form-textarea>
              </b-collapse>
            </b-alert>

            <b-alert show class="margin-bottom alert-dark">
              <h5>
                <b-badge variant="primary">Doctor Discharge :</b-badge>
              </h5>
              <b-row>
                <b-col lg="6">
                  <h6>Discharge Status :</h6>
                  <b-form-select
                    v-model="ptAdmitDischargeStatusSelect"
                    :options="ptAdmitDischargeStatus"
                  ></b-form-select>
                </b-col>

                <b-col lg="6" v-if="ptAdmitDischargeType">
                  <h6>Discharge Type :</h6>
                  <b-form-select
                    v-model="ptAdmitDischargeTypeSelect"
                    :options="ptAdmitDischargeType"
                  ></b-form-select>
                  <h6>Other / By Transfer :</h6>
                  <b-form-input
                    :id="
                      'dchtype-text' + $store.get('systems@LoginData').UserId
                    "
                    :value="dchtype_text"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-alert>
            <div class="log-style" v-if="UserAdmitDischargeSummary">
              Log.
              {{ UserAdmitDischargeSummary.datas.discharge_summary_user_log }} |
              {{
                thaiDatetimeFc.ThaiDateTime(
                  UserAdmitDischargeSummary.datas.discharge_summary_datetime_log
                )
              }}
            </div>
          </b-card>

          <template>
            <b-row>
              <b-col cols="3"> </b-col>
              <b-col cols="6" class="text-align-center">
                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="success"
                  @click="
                    SubmitCheckData(
                      ptAN,
                      'AddDischargeSummary',
                      'ยืนยันการบันทึกข้อมูล'
                    )
                  "
                >
                  บันทึก
                </b-button>

                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="secondary"
                  @click="closeDischargeSummary(SelectdchUser)"
                >
                  ยกเลิก
                </b-button>
              </b-col>
              <b-col cols="3">
                <b-button
                  size="sm"
                  class="margin-left4px"
                  variant="danger"
                  @click="
                    SubmitCheckData(
                      ptAN,
                      'DeleteDischargeSummary',
                      'ยืนยันการลบข้อมูล'
                    )
                  "
                >
                  ลบ
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-collapse>
      </div>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Doctor Note / Plan of treatment :</h5>
      <b-list-group>
        <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
          <b-list-group-item
            variant="primary"
            v-if="
              item.datas.doctor_note != '' && item.datas.doctor_note != null
            "
          >
            <b-row>
              <b-col lg="12" class="margin-bottom">
                <div
                  class="custom-template-text"
                  v-html="TextToHtml(item.datas.doctor_note)"
                ></div>
              </b-col>
            </b-row>
            <div class="pj_clearfix log-style">
              Log.{{ item.datas.doctor_name }} |
              {{
                thaiDatetimeFc.ThaiDateTime(
                  item.datas.discharge_summary_datetime_log
                )
              }}
            </div>
          </b-list-group-item>
        </div>
      </b-list-group>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Hospital Course / Progress Note :</h5>
      <b-list-group>
        <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
          <b-list-group-item
            variant="success"
            v-if="
              item.datas.doctor_course_progressnote != '' &&
                item.datas.doctor_course_progressnote != null
            "
          >
            <b-row>
              <b-col lg="12" class="margin-bottom">
                <div
                  class="custom-template-text"
                  v-html="TextToHtml(item.datas.doctor_course_progressnote)"
                ></div>
              </b-col>
            </b-row>
            <div class="pj_clearfix log-style">
              Log.{{ item.datas.doctor_name }} |
              {{
                thaiDatetimeFc.ThaiDateTime(
                  item.datas.discharge_summary_datetime_log
                )
              }}
            </div>
          </b-list-group-item>
        </div>
      </b-list-group>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Doctor Discharge :</h5>
      <div class="margin-bottom">
        <b-list-group>
          <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
            <b-list-group-item
              variant="info"
              v-if="
                (item.datas.doctor_dchstts_name != null &&
                  item.datas.doctor_dchstts_name != '') ||
                  (item.datas.doctor_dchtype_name != null &&
                    item.datas.doctor_dchtype_name != '')
              "
            >
              <b-row>
                <b-col lg="6">
                  <h6>
                    สถานะการจำหน่วย : {{ item.datas.doctor_dchstts_name }}
                  </h6>
                </b-col>
                <b-col lg="6">
                  <h6>วิธีการจำหน่าย : {{ item.datas.doctor_dchtype_name }}</h6>
                  <h6>
                    Other / By Transfer : {{ item.datas.doctor_dchtype_text }}
                  </h6>
                </b-col>
              </b-row>
              <div class="pj_clearfix log-style">
                Log.{{ item.datas.doctor_name }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.discharge_summary_datetime_log
                  )
                }}
              </div>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>

      <h5>Audit Discharge :</h5>
      <b-list-group>
        <b-list-group-item
          variant="info"
          v-if="
            this.ptAdmitData &&
              this.ptAdmitData.datas.dch_doctor_name != '' &&
              this.ptAdmitData.datas.dch_doctor_name != null
          "
        >
          <b-row>
            <b-col lg="4">
              <h6>
                แพทย์ผู้จำหน่าย :
                {{ this.ptAdmitData && this.ptAdmitData.datas.dch_doctor_name }}
              </h6>
            </b-col>
            <b-col lg="4">
              <h6>
                สถานะการจำหน่วย :
                {{ this.ptAdmitData && this.ptAdmitData.datas.dchstts }}
              </h6>
            </b-col>
            <b-col lg="4">
              <h6>
                วิธีการจำหน่าย :
                {{ this.ptAdmitData && this.ptAdmitData.datas.dchtype }}
              </h6>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Doctor Diag :</h5>
      <div class="margin-bottom">
        <b-list-group>
          <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
            <b-list-group-item
              variant="primary"
              v-if="
                item.datas.doctor_primary_diagnosis != '' ||
                  item.datas.doctor_comorbidity != '' ||
                  item.datas.doctor_complication != '' ||
                  item.datas.doctor_others_diag != ''
              "
            >
              <b-row>
                <b-col
                  lg="12"
                  v-if="item.datas.doctor_primary_diagnosis != ''"
                  class="margin-bottom"
                >
                  <h6 class="margin-bottom-0">Primary Diagnosis :</h6>
                  <div
                    class="custom-template-text"
                    v-html="
                      TextToHtml('- ' + item.datas.doctor_primary_diagnosis)
                    "
                  ></div>
                </b-col>
                <b-col
                  lg="12"
                  v-if="item.datas.doctor_comorbidity != ''"
                  class="margin-bottom"
                >
                  <h6 class="margin-bottom-0">Comorbidity :</h6>
                  <div
                    class="custom-template-text"
                    v-html="TextToHtml('- ' + item.datas.doctor_comorbidity)"
                  ></div>
                </b-col>
                <b-col
                  lg="12"
                  v-if="item.datas.doctor_complication != ''"
                  class="margin-bottom"
                >
                  <h6 class="margin-bottom-0">Complication :</h6>
                  <div
                    class="custom-template-text"
                    v-html="TextToHtml('- ' + item.datas.doctor_complication)"
                  ></div>
                </b-col>
                <b-col
                  lg="12"
                  v-if="item.datas.doctor_others_diag != ''"
                  class="margin-bottom"
                >
                  <h6 class="margin-bottom-0">Others Diag :</h6>
                  <div
                    class="custom-template-text"
                    v-html="TextToHtml('- ' + item.datas.doctor_others_diag)"
                  ></div>
                </b-col>
              </b-row>
              <div class="pj_clearfix log-style">
                Log.{{ item.datas.doctor_name }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.discharge_summary_datetime_log
                  )
                }}
              </div>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>

      <h5>Audit Diag :</h5>
      <b-list-group class="font14px">
        <div v-for="item in this.ptAdmitDiagData" v-bind:key="item.id">
          <b-list-group-item
            variant="primary"
            v-if="item.datas.icd10 != '' && item.datas.icd10 != null"
          >
            <b-row>
              <b-col lg="1"
                ><strong>{{ item.datas.icd10 }}</strong></b-col
              >
              <b-col>{{ item.datas.icd10_name }}</b-col>
              <b-col lg="3">{{
                item.datas.diagtype + " " + item.datas.diagtype_name
              }}</b-col>
              <b-col lg="3">{{ item.datas.doctor_name }}</b-col>
            </b-row>
          </b-list-group-item>
        </div>
      </b-list-group>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Doctor Operation :</h5>
      <div class="margin-bottom">
        <b-list-group>
          <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
            <b-list-group-item
              variant="info"
              v-if="
                item.datas.doctor_operation_procedure != '' ||
                  item.datas.doctor_operation_findings != ''
              "
            >
              <div>
                <b-row>
                  <b-col
                    lg="12"
                    v-if="item.datas.doctor_operation_procedure != ''"
                    class="margin-bottom"
                  >
                    <h6 class="margin-bottom-0">Operation / Procedure :</h6>
                    <div
                      class="custom-template-text"
                      v-html="
                        TextToHtml('- ' + item.datas.doctor_operation_procedure)
                      "
                    ></div>
                  </b-col>
                  <b-col
                    lg="12"
                    v-if="item.datas.doctor_operation_findings != ''"
                    class="margin-bottom"
                  >
                    <h6 class="margin-bottom-0">Operation Findings :</h6>
                    <div
                      class="custom-template-text"
                      v-html="
                        TextToHtml('- ' + item.datas.doctor_operation_findings)
                      "
                    ></div>
                  </b-col>
                </b-row>
                <div class="pj_clearfix log-style">
                  Log.{{ item.datas.doctor_name }} |
                  {{
                    thaiDatetimeFc.ThaiDateTime(
                      item.datas.discharge_summary_datetime_log
                    )
                  }}
                </div>
              </div>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>

      <h5>Audit Operation :</h5>
      <b-list-group class="font14px">
        <div v-for="item in this.ptAdmitOperationData" v-bind:key="item.id">
          <b-list-group-item
            variant="info"
            v-if="item.datas.icd9 != '' && item.datas.icd9 != null"
          >
            <b-row>
              <b-col lg="1"
                ><strong>{{ item.datas.icd9 }}</strong></b-col
              >
              <b-col>{{ item.datas.icd9_name }}</b-col>
              <b-col lg="3"
                ><strong>OP:</strong>
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.opdate + " " + item.datas.optime
                  )
                }}</b-col
              >
              <b-col lg="3"
                ><strong>END:</strong>
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.enddate + " " + item.datas.endtime
                  )
                }}</b-col
              >
              <b-col lg="3">{{ item.datas.doctor_name }}</b-col>
            </b-row>
          </b-list-group-item>
        </div>
      </b-list-group>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Anesthetic Note :</h5>
      <div class="margin-bottom">
        <b-list-group>
          <div v-for="item in ptAdmitDischargeSummary" v-bind:key="item.id">
            <b-list-group-item
              variant="info"
              v-if="item.datas.doctor_anesthetic_note != ''"
            >
              <b-row>
                <b-col lg="12" class="margin-bottom">
                  <h6 class="margin-bottom-0">Anesthetic Note :</h6>
                  <div
                    class="custom-template-text"
                    v-html="
                      TextToHtml('- ' + item.datas.doctor_anesthetic_note)
                    "
                  ></div>
                </b-col>
              </b-row>
              <div class="pj_clearfix log-style">
                Log.{{ item.datas.doctor_name }} |
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.discharge_summary_datetime_log
                  )
                }}
              </div>
            </b-list-group-item>
          </div>
        </b-list-group>
      </div>
    </b-alert>

    <b-alert class="text-left margin-bottom" variant="dark" show>
      <h5>Operative Note Image :</h5>
      <div v-for="item2 in ptAdmitDischargeSummary" v-bind:key="item2.id">
        <b-row>
          <b-col
            class="margin-bottom"
            cols="3"
            v-for="(item, index) in pjFunctionsFc.IPDListDataArrayfilter(
              IPDImageListData,
              item2.loginname
            )"
            v-bind:key="item.id"
          >
            <b-modal
              :id="'modal-ipd-image-view' + item2.loginname + index"
              title="IPD Operative Note Images"
              size="xl"
              hide-footer
            >
              <div class="text-align-center log-style">
                File Name : {{ item.datas.file_name_old }}
              </div>
              <div class="text-align-center log-style">
                User log : {{ item.datas.file_user_name_log }}
              </div>
              <div class="text-align-center log-style">
                DateTime : {{ item.datas.file_datetime }}
              </div>
              <div class="text-align-center margin-bottom">
                <b-img
                  rounded
                  class="image_physical_show"
                  :src="'data:image;base64,' + item.datas.file_base64"
                  v-if="item"
                  :alt="
                    item.datas.file_name_old +
                      '\nLog.' +
                      item.datas.file_user_name_log +
                      ' | ' +
                      item.datas.file_datetime
                  "
                  :title="
                    item.datas.file_name_old +
                      '\nLog.' +
                      item.datas.file_user_name_log +
                      ' | ' +
                      item.datas.file_datetime
                  "
                ></b-img>
              </div>

              <div class="d-block text-center">
                <b-button
                  variant="info"
                  size="sm"
                  class="d-print-none"
                  v-print="'#modal-ipd-image-view' + item2.loginname + index"
                >
                  Print
                </b-button>
                &nbsp;
                <b-button
                  size="sm"
                  class="d-print-none"
                  @click="
                    $bvModal.hide(
                      'modal-ipd-image-view' + item2.loginname + index
                    )
                  "
                  >Close</b-button
                >
              </div>
            </b-modal>
            <b-img
              class="img-preview-ipfs cursor-pointer"
              center
              :src="'data:image;base64,' + item.datas.file_base64"
              :alt="
                item.datas.file_name_old +
                  '\nLog.' +
                  item.datas.file_user_name_log +
                  ' | ' +
                  item.datas.file_datetime
              "
              :title="
                item.datas.file_name_old +
                  '\nLog.' +
                  item.datas.file_user_name_log +
                  ' | ' +
                  item.datas.file_datetime
              "
              v-b-modal="'modal-ipd-image-view' + item2.loginname + index"
            ></b-img>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            class="margin-bottom"
            cols="3"
            v-for="(item, index) in pjFunctionsFc.IpfsListDataArrayfilter(
              IpfsListData,
              item2.loginname
            )"
            v-bind:key="item.id"
          >
            <b-modal
              :id="'modal-ipfs-ipd-image-view' + item2.loginname + index"
              title="IPD Operative Note Images on IPFS"
              size="xl"
              hide-footer
            >
              <div class="text-align-center log-style">
                File Name : {{ item.file_name }}
              </div>
              <div class="text-align-center log-style">
                User log : {{ item.ipfs_file_user }}
              </div>
              <div class="text-align-center log-style">
                DateTime : {{ item.datas.ipfs_file_datetime }}
              </div>
              <div class="text-align-center margin-bottom">
                <b-img
                  rounded
                  class="image_physical_show"
                  :src="'data:image;base64,' + item.files_base64"
                  v-if="item"
                  :alt="
                    item.datas.file_name +
                      '\nLog.' +
                      item2.datas.doctor_name +
                      ' | ' +
                      item.datas.ipfs_file_datetime
                  "
                  :title="
                    item.datas.file_name +
                      '\nLog.' +
                      item2.datas.doctor_name +
                      ' | ' +
                      item.datas.ipfs_file_datetime
                  "
                ></b-img>
              </div>

              <div class="d-block text-center">
                <b-button
                  variant="info"
                  size="sm"
                  class="d-print-none"
                  v-print="
                    '#modal-ipfs-ipd-image-view' + item2.loginname + index
                  "
                >
                  Print
                </b-button>
                &nbsp;
                <b-button
                  size="sm"
                  class="d-print-none"
                  @click="
                    $bvModal.hide(
                      'modal-ipfs-ipd-image-view' + item2.loginname + index
                    )
                  "
                  >Close</b-button
                >
              </div>
            </b-modal>

            <b-img
              class="img-preview-ipfs cursor-pointer"
              center
              :src="'data:image;base64,' + item.files_base64"
              :alt="
                item.datas.ipfs_file_name +
                  '\nLog.' +
                  item2.datas.doctor_name +
                  ' | ' +
                  item.datas.ipfs_file_datetime
              "
              :title="
                item.datas.ipfs_file_name +
                  '\nLog.' +
                  item2.datas.doctor_name +
                  ' | ' +
                  item.datas.ipfs_file_datetime
              "
              v-b-modal="'modal-ipfs-ipd-image-view' + item2.loginname + index"
            ></b-img>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="pj_clearfix log-style">
              Log.{{ item2.datas.doctor_name }} |
              {{
                thaiDatetimeFc.ThaiDateTime(
                  item2.datas.discharge_summary_datetime_log
                )
              }}
              <hr />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-alert>

    <b-alert show class="text-left margin-bottom" variant="dark">
      <h5>Home Medication :</h5>
      <b-list-group class="font14px">
        <b-list-group-item>
          <b-row>
            <b-col
              lg="6"
              v-for="(item, index) in this.ptAdmitHomeMedData"
              v-bind:key="item.id"
              class="margin-bottom"
            >
              <b-alert variant="success" show>
                <div>{{ index + 1 }}. {{ item.datas.drugNondugFullName }}</div>
                <div class="font12px">
                  {{
                    item.datas.drug_usage_ename &&
                      "- " + item.datas.drug_usage_ename
                  }}
                </div>
              </b-alert>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-alert>

    <EmrAdmitOrderImage v-bind:my-hn="this.ptHN" v-bind:my-an="this.ptAN" />

    <b-alert show class="text-left margin-bottom" variant="dark">
      <h5>Admit Rx Order :</h5>
      <div>
        <b-row>
          <b-modal
            id="modal-admit-rx-order-data"
            title="Admit Rx Order"
            size="xl"
            ok-only
            button-size="sm"
            :no-close-on-backdrop="true"
            :close-on-esc="true"
          >
            <b-card class="text-left card-custom">
              <div
                v-for="(item, index) in this.ptAdmitRxOrderData"
                v-bind:key="item.id"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <h5>
                    <b-badge
                      variant="success"
                      href="#"
                      v-b-toggle="'Rx' + index"
                    >
                      {{ item.datas.order_type }} : {{ item.datas.order_no }} |
                      Date :
                      {{
                        thaiDatetimeFc.ThaiDateTime(
                          item.datas.rxdate + " " + item.datas.rxtime
                        )
                      }}
                    </b-badge>
                  </h5>
                </b-card-header>

                <b-collapse
                  :id="'Rx' + index"
                  accordion="my-rx-order"
                  role="tabpanel-rx-order"
                  :visible="index == 0"
                >
                  <b-alert show variant="dark" class="margin-bottom">
                    <b-row>
                      <b-col
                        lg="6"
                        v-for="(item2, index2) in getRxOrderDetailData(
                          item.vn,
                          item.hn,
                          item.an,
                          item.order_no
                        )"
                        v-bind:key="item2.id"
                        class="margin-bottom"
                      >
                        <b-alert show variant="primary" class="font14px">
                          <div>
                            {{ index2 + 1 }}.
                            {{ item2.datas.drugNondugFullName }}
                          </div>
                          <div class="font12px">
                            {{
                              item2.datas.drug_usage_ename &&
                                "- " + item2.datas.drug_usage_ename
                            }}
                          </div>
                        </b-alert>
                      </b-col>
                    </b-row>
                  </b-alert>
                </b-collapse>
              </div>
            </b-card>
          </b-modal>

          <div class="margin-left8px">
            <b-button
              variant="info"
              size="sm"
              @click="setAllDrugNonDrugData(ptHN, ptAN)"
              v-show="false"
              >Admit Rx Order</b-button
            >

            <b-img
              thumbnail
              rounded="circle"
              alt="Admit Rx Order"
              title="Admit Rx Order"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgRxOrderIcon"
              @click="setAllDrugNonDrugData(ptHN, ptAN)"
            ></b-img>
          </div>
        </b-row>
      </div>
    </b-alert>

    <div>
      <EmrXrayIPD
        v-bind:my-vn="this.ptVN"
        v-bind:my-hn="this.ptHN"
        v-bind:my-an="this.ptAN"
      ></EmrXrayIPD>
    </div>

    <div>
      <EmrLabIPD
        v-bind:my-vn="this.ptVN"
        v-bind:my-hn="this.ptHN"
        v-bind:my-an="this.ptAN"
        v-bind:row-limit="5"
      ></EmrLabIPD>
    </div>

    <div>
      <b-modal
        id="modal-admit-lab-show-all"
        title="Lab Admit"
        size="xl"
        hide-footer
        button-size="sm"
        :no-close-on-backdrop="true"
        :close-on-esc="true"
      >
        <div id="admit-lab-show-all">
          <b-card
            bg-variant="danger"
            text-variant="white"
            class="text-left margin-bottom"
          >
            <b-row>
              <b-col lg="3">
                {{ vnChang }}
                <h5>
                  AN : {{ this.ptAdmitData && this.ptAdmitData.datas.an }}
                </h5>
              </b-col>
              <b-col lg="3">
                <h5>HN : {{ this.ptData && this.ptData.datas.hn }}</h5>
              </b-col>
              <b-col>
                <h5>
                  ชื่อ-สกุล
                  {{
                    this.ptData &&
                      this.ptData.datas.pname +
                        this.ptData.datas.fname +
                        "  " +
                        this.ptData.datas.lname
                  }}
                </h5>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="3">
                <h5>
                  CID : {{ this.ptAdmitData && this.ptAdmitData.datas.cid }}
                </h5>
              </b-col>
              <b-col lg="3">
                <h6>
                  วันที่รับ :
                  {{
                    this.ptAdmitData &&
                      this.thaiDatetimeFc.ThaiDateTime(
                        this.ptAdmitData.datas.regdate +
                          " " +
                          this.ptAdmitData.datas.regtime
                      )
                  }}
                </h6>
              </b-col>
              <b-col>
                <h6>
                  วันที่จำหน่วย :
                  {{
                    this.ptAdmitData &&
                      this.thaiDatetimeFc.ThaiDateTime(
                        this.ptAdmitData.datas.dchdate +
                          " " +
                          this.ptAdmitData.datas.dchtime
                      )
                  }}
                </h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h6 class="font-color-warning2">
                  อาการสำคัญ :
                  {{ this.ptAdmitData && this.ptAdmitData.datas.prediag }}
                </h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="4">
                <h6>
                  แพทย์เจ้าของไข้ :
                  {{
                    this.ptAdmitData &&
                      this.ptAdmitData.datas.incharge_doctor_name
                  }}
                </h6>
              </b-col>
              <b-col lg="4">
                <h6>
                  Ward :
                  {{ this.ptAdmitData && this.ptAdmitData.datas.ward_name }}
                </h6>
              </b-col>
              <b-col>
                <h6>
                  แผนก :
                  {{ this.ptAdmitData && this.ptAdmitData.datas.spclty_name }}
                </h6>
              </b-col>
            </b-row>

            <b-row v-if="this.ptData && this.ptData.datas.clinic">
              <b-col>
                <h5 class="font-color-warning2">
                  โรคประจำตัว : {{ this.ptData && this.ptData.datas.clinic }}
                </h5>
              </b-col>
            </b-row>

            <b-row v-if="this.ptData && this.ptData.datas.drugallergy">
              <b-col>
                <h5 class="font-color-warning2">
                  แพ้ยา : {{ this.ptData && this.ptData.datas.drugallergy }}
                </h5>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h6>
                  สิทธิประจำตัว :
                  {{
                    this.ptData &&
                      this.pjFunctionsFc.NulltoStr(this.ptData.datas.pttype) +
                        " " +
                        this.pjFunctionsFc.NulltoStr(
                          this.ptData.datas.pttype_name
                        )
                  }}
                </h6>
              </b-col>
            </b-row>
          </b-card>

          <EmrLabIPD2
            v-bind:my-vn="this.ptVN"
            v-bind:my-hn="this.ptHN"
            v-bind:my-an="this.ptAN"
            v-bind:row-limit="0"
            v-if="LabShowAll"
          ></EmrLabIPD2>
        </div>

        <div class="d-block text-center">
          <b-button
            variant="info"
            size="sm"
            class="d-print-none"
            v-print="'#admit-lab-show-all'"
          >
            Print
          </b-button>
          &nbsp;
          <b-button
            size="sm"
            class="d-print-none"
            @click="$bvModal.hide('modal-admit-lab-show-all')"
            >Close</b-button
          >
        </div>
      </b-modal>
    </div>
    <div v-if="this.LabHeadCount > 5">
      <b-button
        pill
        variant="primary"
        class="d-print-none"
        size="sm"
        @click="clickLabShowAll()"
        >ดู Lab ทั้งหมด</b-button
      >
    </div>

    <div class="d-block text-center">
      <b-button
        variant="info"
        size="sm"
        class="d-print-none"
        v-print="'#admit-data-div'"
      >
        Print
      </b-button>
      &nbsp;
      <b-button
        size="sm"
        class="d-print-none"
        @click="$bvModal.hide('modal-admit-data')"
        >Close</b-button
      >
    </div>

    <!-- CSS animation example -->
    <notifications
      group="emr-admit-foo-css"
      position="top right"
      animation-name="v-fade-left"
      :speed="500"
    >
    </notifications>

    <!-- Custom template example -->
    <notifications
      group="emr-admit-custom-save"
      :speed="500"
      animation-name="v-fade-left"
      position="bottom right"
    >
      <template slot="body" slot-scope="props">
        <div class="emr-admit-custom-save">
          <div
            class="notification-wrapper cursor-pointer"
            style="transition-timing-function: ease; transition-delay: 0s; transition-property: all;"
            @click="props.close"
          >
            <div class="vue-notification-template vue-notification">
              <div class="notification-title">{{ props.item.title }}</div>
              <div class="custom-template-text" v-html="props.item.text"></div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import PatientData from "@/models/patientEMRs/PatientData";
import PatientAdmitData from "@/models/patientEMRs/PatientAdmitData";
import PatientAdmitDiagData from "@/models/patientEMRs/PatientAdmitDiagData";
import PatientAdmitOperationData from "@/models/patientEMRs/PatientAdmitOperationData";
import PatientDrugNoneDrug from "@/models/patientEMRs/PatientDrugNoneDrug";
import PatientAdmitRxOrderData from "@/models/patientEMRs/PatientAdmitRxOrderData";
import PatientAdmitDischargeSummary from "@/models/patientEMRs/PatientAdmitDischargeSummary";
import PatientAdmitDischargeType from "@/models/patientEMRs/PatientAdmitDischargeType";
import PatientAdmitDischargeStatus from "@/models/patientEMRs/PatientAdmitDischargeStatus";

import EmrXrayIPD from "@/components/PatientEMR/EmrXrayIPD";
import EmrLabIPD from "@/components/PatientEMR/EmrLabIPD";

import EmrDocumentScanIPD from "@/components/PatientEMR/EmrDocumentScanIPD";
import DocumentScanIPD from "@/models/patientEMRs/DocumentScanIPD";

import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";
import PatientLabHead from "@/models/patientEMRs/PatientLabHead";

import PatientEmrIpfsOperativeNoteImage from "@/models/patientEMRs/PatientEmrIpfsOperativeNoteImage";
import PatientIpdImage from "@/models/patientEMRs/PatientIpdImage";
import PatientAdmitDischargeSummaryCodingAudit from "@/models/patientEMRs/PatientAdmitDischargeSummaryCodingAudit";

import EmrAdmitOrderImage from "@/components/PatientEMR/EmrAdmitOrderImage";

const RxOrderIcon = require("@/images/Rx40-512.png");
const EMRIcon = require("@/images/EMR16-512.png");

Vue.component("EmrXrayIPD", EmrXrayIPD);
Vue.component("EmrLabIPD", EmrLabIPD);
Vue.component("EmrLabIPD2", EmrLabIPD);
Vue.component("EmrAdmitOrderImage", EmrAdmitOrderImage);
Vue.component("EmrDocumentScanIPD", EmrDocumentScanIPD);

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      ptHN: "",
      ptVN: "",
      ptAN: "",
      ptData: null,
      ptAdmitData: null,
      ptAdmitDiagData: null,
      ptAdmitOperationData: null,
      ptAdmitHomeMedData: null,
      ptAdmitRxOrderData: null,
      ptAdmitDischargeSummary: null,
      UserAdmitDischargeSummary: null,
      ptAdmitDischargeType: null,
      ptAdmitDischargeStatus: null,
      ptAdmitDischargeTypeSelect: "",
      ptAdmitDischargeStatusSelect: "",
      primary_diagnosis: "",
      comorbidity: "",
      complication: "",
      others_diag: "",
      course_progressnote: "",
      anesthetic_note: "",
      operation_procedure: "",
      operation_findings: "",
      doctor_note: "",
      dchtype_text: "",
      primary_diagnosis_show: false,
      comorbidity_show: false,
      complication_show: false,
      others_diag_show: false,
      course_progressnote_show: false,
      anesthetic_note_show: false,
      operation_procedure_show: false,
      operation_findings_show: false,
      doctor_note_show: false,
      hasImage: false,
      IpfsListData: [],
      IpfsUrl: "",
      IPDImageListData: [],
      DDD: {
        sss: ""
      },
      LabShowAll: false,
      LabHeadCount: 0,
      SelectdchUser: "",
      SelectCodingAuditdchUser: "",
      ModulRightCheck: false,

      CodingAuditUserAdmitDischargeSummary: null,
      CodingAuditptAdmitDischargeStatusSelect: "",
      CodingAuditptAdmitDischargeTypeSelect: "",
      coding_audit_primary_diagnosis: "",
      coding_audit_comorbidity: "",
      coding_audit_complication: "",
      coding_audit_others_diag: "",
      coding_audit_course_progressnote: "",
      coding_audit_anesthetic_note: "",
      coding_audit_operation_procedure: "",
      coding_audit_operation_findings: "",
      coding_audit_doctor_note: "",
      coding_audit_dchtype_text: "",
      coding_audit_data_status: false,
      imgRxOrderIcon: RxOrderIcon,
      imgEMRIcon: EMRIcon,
      DocumentScanIPDLoadSTD: false
    };
  },
  props: ["MyVn", "MyHn", "MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientData,
    PatientAdmitData,
    PatientAdmitDiagData,
    PatientAdmitOperationData,
    PatientDrugNoneDrug,
    PatientAdmitRxOrderData,
    PatientAdmitDischargeSummary,
    PatientAdmitDischargeSummaryCodingAudit,
    PatientAdmitDischargeType,
    PatientAdmitDischargeStatus,
    PatientEmrIpfsOperativeNoteImage,
    PatientLabHead,
    DocumentScanIPD
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
  },
  watch: {
    MyVn: function() {
      this.vnChang;
    },
    MyHn: function() {
      this.vnChang;
    },
    MyAn: function() {
      this.vnChang;
    },
    ptVN: function() {
      this.getData(
        this.ptVN,
        this.ptHN,
        this.ptAN,
        "ptData",
        this.$store.get("systems@LoginData").UserId
      );
    },
    ptAN: function() {
      this.setData(this.ptVN, this.ptHN, this.ptAN);
      this.getData(
        this.ptVN,
        this.ptHN,
        this.ptAN,
        "ptData",
        this.$store.get("systems@LoginData").UserId
      );
      /*
        this.getData(this.ptVN,this.ptHN,this.ptAN,'AdmitDischargeType')
        
        this.getData(this.ptVN,this.ptHN,this.ptAN,'AdmitDischargeStatus')*/
    }
  },
  computed: {
    vnChang: function() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.ptAN = this.MyAn;

      this.getData(
        this.MyVn,
        this.MyHn,
        this.MyAn,
        "AdmitDischargeType",
        this.$store.get("systems@LoginData").UserId
      );

      this.getData(
        this.MyVn,
        this.MyHn,
        this.MyAn,
        "AdmitDischargeStatus",
        this.$store.get("systems@LoginData").UserId
      );
    }
  },
  mounted() {
    this.chkUserModulRightCheck();
  },
  methods: {
    chkUserModulRightCheck() {
      if (this.$store.get("systems@LoginStatus")) {
        if (
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "Audit"
          )
        ) {
          this.ModulRightCheck = true;
        } else {
          this.ModulRightCheck = false;
        }
      } else {
        this.ModulRightCheck = false;
      }
    },
    selectDataDCH(vn, hn, an, userDCH) {
      this.SelectdchUser = userDCH;
      this.getData(vn, hn, an, "AdmitDischargeSummary", userDCH);

      setTimeout(() => {
        // this.$bvModal.show('modal-admit-discharge-summary-ed-'+userDCH);
        this.$root.$emit(
          "bv::toggle::collapse",
          "modal-admit-discharge-summary-ed-" + userDCH
        );
      }, 500);
    },
    selectCodingAuditDataDCH(vn, hn, an, userDCH) {
      this.SelectCodingAuditdchUser = userDCH;
      this.getData(vn, hn, an, "AdmitDischargeSummaryCodingAudit", userDCH);

      setTimeout(() => {
        // this.$bvModal.show('modal-admit-discharge-summary-ed-'+userDCH);
        this.$root.$emit(
          "bv::toggle::collapse",
          "modal-admit-discharge-summary-coding-audit-ed-" + userDCH
        );
      }, 500);
    },
    viewEMR(hn) {
      store.set("systems@SearchPT", true);
      store.set("systems@SearchPTid", hn);

      this.$router.push({
        path: "/PatientEMR/" + hn
      });
    },
    clickLabShowAll() {
      this.LabShowAll = true;
      this.$bvModal.show("modal-admit-lab-show-all");
    },

    setAllDrugNonDrugData(hn, an) {
      let DataObj = this;
      let data = [];

      /** Admit Drug & NoneDrug Load */
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DrugNonDrugData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an
        })
        .then(function(response) {
          DataObj.output = response.data;
          if (DataObj.output.status === true) {
            PatientDrugNoneDrug.delete({
              where(record) {
                return record.an == an;
              }
            });

            data = [];
            for (var val of DataObj.output.result) {
              data.push({
                id: val.hos_guid,
                hn: val.hn,
                vn: val.vn,
                an: val.an,
                datas: val
              });
            }

            PatientDrugNoneDrug.insertOrUpdate({
              data
            });
          } else {
            if (DataObj.output.ErrorMessage === "Data Not Found") {
              PatientDrugNoneDrug.delete({
                where(record) {
                  return record.an == an;
                }
              });
            }
          }
        })
        .catch(function(error) {
          DataObj.output = error;
          console.log("DrugNonDrugData : " + DataObj.output);
        })
        .finally(function() {
          DataObj.$bvModal.show("modal-admit-rx-order-data");
        });
    },

    setImage: function(output) {
      this.hasImage = true;
      this.image = output;
      // console.log(this.image.data);
    },
    endImageResize() {
      let Obj2 = this;
      let filesAddAtd = false;

      let formData = new FormData();

      formData.append("token_key", this.$store.get("systems@token_key"));
      formData.append("file_user", this.$store.get("systems@LoginData").UserId);

      formData.append("CompanyId", this.$store.get("systems@CompanyId"));
      formData.append("ApiKey", this.$store.get("systems@ApiKey"));
      formData.append("ipfs_action", "files-add-files");

      formData.append("key1", "emr-opd-image");
      formData.append("key2", "operative-note");
      formData.append("key3", "");
      formData.append("an", this.ptAN);
      formData.append("hn", this.ptHN);
      formData.append("files", this.image);

      this.axios
        .post(this.$store.get("systems@UrlApi") + "Call-IPFS-files", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          Obj2.output = response.data;

          if (Obj2.output.status === true) {
            filesAddAtd = true;
          } else {
            filesAddAtd = false;
          }
        })
        .catch(function(error) {
          Obj2.output = error;
          console.log("files-add : " + Obj2.output);
        })
        .finally(function() {
          // console.log("OPOPO", Obj2.output.result);
          Obj2.ImageInsert(Obj2.output.result);
          // Obj2.DataCh = "files-add" + vn;
        });
    },

    ImageInsert(datas) {
      let SendData = datas[0];
      let ScrObj = this;
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "EmrIpfsOperativeNoteImageAdd",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: this.ptHN,
            an: this.ptAN,
            ipfs_file_hash: SendData.ipfs_file_hash,
            key1: SendData.key1,
            key2: SendData.key2,
            key3: SendData.key3,
            ipfs_token_key: SendData.ipfs_token_key,
            ipfs_file_name: SendData.ipfs_file_name,
            ipfs_file_type: SendData.ipfs_file_type,
            ipfs_file_extension: SendData.ipfs_file_extension
          }
        )
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            // ddd
          } else {
            // console.log('EmrIpfsOperativeNoteImageAdd : '+ScrObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("EmrIpfsOperativeNoteImageAdd : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.setIpfsList(ScrObj.ptAN, ScrObj.ptHN);
        });
    },

    IPFSIPDImageDel(hash) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการลบรูปภาพ. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            let ScrObj = this;
            this.axios
              .post(
                this.$store.get("systems@UrlApi") +
                  "EmrIpfsOperativeNoteImageRemove",
                {
                  CompanyId: this.$store.get("systems@CompanyId"),
                  ApiKey: this.$store.get("systems@ApiKey"),
                  ipfs_action: "files-remove",
                  file_user: this.$store.get("systems@LoginData").UserId,
                  hn: this.ptHN,
                  an: this.ptAN,
                  key1: "emr-opd-image",
                  key2: "operative-note",
                  key3: "",
                  token_key: this.$store.get("systems@token_key"),
                  hash: hash
                }
              )
              .then(function(response) {
                ScrObj.output = response.data;
                if (ScrObj.output.status === true) {
                  // ddd
                } else {
                  // console.log('EmrIpfsOperativeNoteImageRemove : '+ScrObj.output.ErrorMessage)
                }
              })
              .catch(function(error) {
                ScrObj.output = error;
                console.log(
                  "EmrIpfsOperativeNoteImageRemove : " + ScrObj.output
                );
              })
              .finally(function() {
                ScrObj.setIpfsList(ScrObj.ptAN, ScrObj.ptHN);
              });
          }
        });
    },

    setIpfsList(an, hn) {
      let Obj6 = this;
      this.axios
        .post(
          this.$store.get("systems@UrlApi") + "EmrIpfsOperativeNoteImageGet",
          {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an,
            key1: "emr-opd-image",
            key2: "operative-note",
            key3: ""
          }
        )
        .then(function(response) {
          Obj6.output = response.data;
          if (Obj6.output.status === true) {
            PatientEmrIpfsOperativeNoteImage.delete({
              where(record) {
                return record.an == an && record.key2 == "operative-note";
              }
            });

            let data = [];
            for (var val of Obj6.output.result) {
              data.push({
                id: val.ipfs_file_hash + val.ipfs_file_user,
                ipfs_file_user: val.ipfs_file_user,
                an: val.an,
                hn: val.hn,
                key1: val.key1,
                key2: val.key2,
                key3: val.key3,
                datas: val,
                list_orderby: val.list_orderby
              });
            }

            PatientEmrIpfsOperativeNoteImage.insertOrUpdate({
              data
            });
          } else {
            // console.log('EmrIpfsImageGet : '+Obj5.output.ErrorMessage)
            if (Obj6.output.ErrorMessage === "Data Not Found") {
              PatientEmrIpfsOperativeNoteImage.delete({
                where(record) {
                  record.an == an && record.key2 == "operative-note";
                }
              });
            }
          }
        })
        .catch(function(error) {
          Obj6.output = error;
          console.log("EmrIpfsImageGet : " + Obj6.output);
        })
        .finally(function() {
          Obj6.getIpfsList(Obj6.ptAN, Obj6.ptHN);
        });
    },

    getIpfsList(an, hn) {
      let IpfsUrlObj = PatientWebbaseUrl.query()
        .where(record => record.web_name == "IPFS-S1")
        .where(record => record.datas.web_status == "Y")
        .get();

      if (IpfsUrlObj.length > 0) {
        this.IpfsUrl = IpfsUrlObj[0].web_host;
      }

      let ScrObj = PatientEmrIpfsOperativeNoteImage.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.an == an)
        .where(record => record.key1 == "emr-opd-image")
        .where(record => record.key2 == "operative-note")
        .where(record => record.key3 == "")
        .get();

      if (ScrObj.length > 0) {
        this.IpfsListData = [];
        let Obj2 = this;
        let datas = [];
        let n = 0;
        let result = null;
        let dd = null;
        for (var val of ScrObj) {
          dd = {
            ipfs_file_user: val.datas.ipfs_file_user,
            ipfs_file_name: val.datas.ipfs_file_name,
            ipfs_file_datetime: val.datas.ipfs_file_datetime,
            an: val.datas.an,
            hn: val.datas.hn,
            key1: val.datas.key1,
            key2: val.datas.key2,
            key3: val.datas.key3,
            ipfs_file_hash: val.datas.ipfs_file_hash
          };

          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "Call-IPFS-files-get-base64",
              {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                token_key: this.$store.get("systems@token_key"),
                hash: val.datas.ipfs_file_hash,
                datas: dd
              }
            )
            .then(function(response) {
              Obj2.output = response.data;
              if (Obj2.output.status === true) {
                Obj2.IpfsListData.push({
                  file_name: Obj2.output.result.file_name,
                  files_base64: Obj2.output.result.files_base64,
                  ipfs_file_user: Obj2.output.result.datas.ipfs_file_user,
                  an: Obj2.output.result.datas.an,
                  hn: Obj2.output.result.datas.hn,
                  key1: Obj2.output.result.datas.key1,
                  key2: Obj2.output.result.datas.key2,
                  key3: Obj2.output.result.datas.key3,
                  datas: Obj2.output.result.datas
                });
              }
            })
            .catch(function(error) {
              Obj2.output = error;
              console.log("files-get : " + Obj2.output);
            })
            .finally(function() {
              // console.log("ddd", Obj2.IpfsListData);
            });
        }
      } else {
        this.IpfsListData = [];
      }
    },

    show(group, type = "", title = "", text = "") {
      //const text = `
      //  This is notification text!
      //  <br>
      //  Date: ${new Date()}
      // `
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },

    loadDocumentScanIPD(hn, vn, an) {
      let ScrObjDc = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DocumentScanIPD", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an
        })
        .then(function(response) {
          ScrObjDc.output = response.data;
          if (ScrObjDc.output.status === true) {
            DocumentScanIPD.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            DocumentScanIPD.insertOrUpdate({
              data: {
                id: ScrObjDc.output.result.hn,
                hn: ScrObjDc.output.result.hn,
                an: ScrObjDc.output.result.an,
                documentGroups: ScrObjDc.output.result.documentScans,
                documentScans: "",
                documentLocation: ScrObjDc.output.result.documentLocation
              }
            });
          } else {
            if (ScrObjDc.output.ErrorMessage === "Data Not Found") {
              DocumentScanIPD.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          ScrObjDc.output = error;
          console.log("DocumentScanIPD : " + ScrObjDc.output);
        })
        .finally(function() {
          ScrObjDc.DocumentScanIPDLoadSTD = true;
          //LOAD ScrObjDc.loadOpdErProgressNote(hn, vn);
        });
    },

    SubmitCheckData(an, action, msgText) {
      // console.log('sss0', document.getElementById('primary-diagnosis'+this.$store.get('systems@LoginData').UserId).value)

      this.primary_diagnosis = document.getElementById(
        "primary-diagnosis" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.comorbidity = document.getElementById(
        "comorbidity" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.complication = document.getElementById(
        "complication" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.others_diag = document.getElementById(
        "others-diag" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.course_progressnote = document.getElementById(
        "course-progressnote" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.anesthetic_note = document.getElementById(
        "course-anesthetic-note" + this.$store.get("systems@LoginData").UserId
      ).value;
      this.operation_procedure = document.getElementById(
        "course-operation-procedure" +
          this.$store.get("systems@LoginData").UserId
      ).value;
      this.operation_findings = document.getElementById(
        "course-operation-findings" +
          this.$store.get("systems@LoginData").UserId
      ).value;
      this.doctor_note = document.getElementById(
        "course-doctor-note" + this.$store.get("systems@LoginData").UserId
      ).value;

      this.dchtype_text = document.getElementById(
        "dchtype-text" + this.$store.get("systems@LoginData").UserId
      ).value;

      this.SubmitConfirm(an, action, msgText);
    },
    CodingAuditSubmitCheckData(an, action, msgText) {
      this.coding_audit_primary_diagnosis = document.getElementById(
        "primary-diagnosis" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_comorbidity = document.getElementById(
        "comorbidity" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_complication = document.getElementById(
        "complication" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_others_diag = document.getElementById(
        "others-diag" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_course_progressnote = document.getElementById(
        "course-progressnote" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_anesthetic_note = document.getElementById(
        "course-anesthetic-note" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_operation_procedure = document.getElementById(
        "course-operation-procedure" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_operation_findings = document.getElementById(
        "course-operation-findings" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_doctor_note = document.getElementById(
        "course-doctor-note" + this.SelectCodingAuditdchUser
      ).value;
      this.coding_audit_dchtype_text = document.getElementById(
        "dchtype-text" + this.SelectCodingAuditdchUser
      ).value;

      this.SubmitConfirm(an, action, msgText);
    },
    SubmitConfirm(an, action, msgText) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm(msgText, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.SubmitDischargeSummary(an, action);
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    SubmitDischargeSummary(an, action) {
      if (an != "" && action != "") {
        if (action == "AddDischargeSummary") {
          if (
            this.SelectdchUser <= "" ||
            this.SelectdchUser == null ||
            this.SelectdchUser == "null"
          ) {
            this.SelectdchUser = this.$store.get("systems@LoginData").UserId;
          }

          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            primary_diagnosis: this.primary_diagnosis,
            comorbidity: this.comorbidity,
            complication: this.complication,
            others_diag: this.others_diag,
            course_progressnote: this.course_progressnote,
            anesthetic_note: this.anesthetic_note,
            operation_procedure: this.operation_procedure,
            operation_findings: this.operation_findings,
            doctor_note: this.doctor_note,
            doctor_dchstts: this.ptAdmitDischargeStatusSelect,
            doctor_dchtype: this.ptAdmitDischargeTypeSelect,
            dchtype_text: this.dchtype_text,
            action: action,
            dch_user: this.SelectdchUser
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "AdmitDischargeSummaryAction",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "success",
                  "Save Data Success",
                  "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // ScrObj.$bvModal.hide('modal-admit-discharge-summary-ed-'+ScrObj.$store.get('systems@LoginData').UserId);

                ScrObj.$root.$emit(
                  "bv::toggle::collapse",
                  "modal-admit-discharge-summary-ed-" +
                    ScrObj.$store.get("systems@LoginData").UserId
                );
              } else {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "warn",
                  "Save Data Error",
                  "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log("AdmitDischargeSummaryAction : " + ScrObj.output);
            })
            .finally(function() {
              ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);
            });
        }

        if (action == "DeleteDischargeSummary") {
          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            primary_diagnosis: this.primary_diagnosis,
            comorbidity: this.comorbidity,
            complication: this.complication,
            others_diag: this.others_diag,
            course_progressnote: this.course_progressnote,
            anesthetic_note: this.anesthetic_note,
            operation_procedure: this.operation_procedure,
            operation_findings: this.operation_findings,
            doctor_note: this.doctor_note,
            doctor_dchstts: this.ptAdmitDischargeStatusSelect,
            doctor_dchtype: this.ptAdmitDischargeTypeSelect,
            dchtype_text: this.dchtype_text,
            action: action
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "AdmitDischargeSummaryAction",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "success",
                  "Save Data Success",
                  "การลบข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // ScrObj.$bvModal.hide('modal-admit-discharge-summary-ed-'+ScrObj.$store.get('systems@LoginData').UserId);

                ScrObj.$root.$emit(
                  "bv::toggle::collapse",
                  "modal-admit-discharge-summary-ed-" +
                    ScrObj.$store.get("systems@LoginData").UserId
                );
              } else {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "warn",
                  "Save Data Error",
                  "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                // console.log('DrugNonDrugNoteAdd : '+ScrObj.output.ErrorMessage)
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log("AdmitDischargeSummaryAction : " + ScrObj.output);
            })
            .finally(function() {
              ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);
            });
        }

        if (action == "AddDischargeSummaryCodingAudit") {
          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            primary_diagnosis: this.coding_audit_primary_diagnosis,
            comorbidity: this.coding_audit_comorbidity,
            complication: this.coding_audit_complication,
            others_diag: this.coding_audit_others_diag,
            course_progressnote: this.coding_audit_course_progressnote,
            anesthetic_note: this.coding_audit_anesthetic_note,
            operation_procedure: this.coding_audit_operation_procedure,
            operation_findings: this.coding_audit_operation_findings,
            doctor_note: this.coding_audit_doctor_note,
            doctor_dchstts: this.CodingAuditptAdmitDischargeStatusSelect,
            doctor_dchtype: this.CodingAuditptAdmitDischargeTypeSelect,
            dchtype_text: this.coding_audit_dchtype_text,
            action: action,
            dch_user: this.SelectCodingAuditdchUser
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") +
                "AdmitDischargeSummaryCodingAuditAction",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "success",
                  "Save Data Success",
                  "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                ScrObj.$root.$emit(
                  "bv::toggle::collapse",
                  "modal-admit-discharge-summary-coding-audit-ed-" +
                    ScrObj.SelectCodingAuditdchUser
                );
              } else {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "warn",
                  "Save Data Error",
                  "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log(
                "AdmitDischargeSummaryCodingAuditAction : " + ScrObj.output
              );
            })
            .finally(function() {
              ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);
            });
        }

        if (action == "DeleteDischargeSummaryCodingAudit") {
          let RequestData = {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            an: an,
            hn: this.ptHN,
            primary_diagnosis: this.coding_audit_primary_diagnosis,
            comorbidity: this.coding_audit_comorbidity,
            complication: this.coding_audit_complication,
            others_diag: this.coding_audit_others_diag,
            course_progressnote: this.coding_audit_course_progressnote,
            anesthetic_note: this.coding_audit_anesthetic_note,
            operation_procedure: this.coding_audit_operation_procedure,
            operation_findings: this.coding_audit_operation_findings,
            doctor_note: this.coding_audit_doctor_note,
            doctor_dchstts: this.CodingAuditptAdmitDischargeStatusSelect,
            doctor_dchtype: this.CodingAuditptAdmitDischargeTypeSelect,
            dchtype_text: this.coding_audit_dchtype_text,
            action: action,
            dch_user: this.SelectCodingAuditdchUser
          };

          let ScrObj = this;
          this.axios
            .post(
              this.$store.get("systems@UrlApi") +
                "AdmitDischargeSummaryCodingAuditAction",
              RequestData
            )
            .then(function(response) {
              ScrObj.output = response.data;
              if (ScrObj.output.status === true) {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "success",
                  "Save Data Success",
                  "การลบข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );

                ScrObj.$root.$emit(
                  "bv::toggle::collapse",
                  "modal-admit-discharge-summary-coding-audit-ed-" +
                    ScrObj.SelectCodingAuditdchUser
                );
              } else {
                ScrObj.show(
                  "emr-admit-foo-css",
                  "warn",
                  "Save Data Error",
                  "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                    "<br>ErrorMessage : " +
                    ScrObj.output.ErrorMessage +
                    "<br>Date : " +
                    ScrObj.thaiDatetimeFc.ThaiDateTime(
                      ScrObj.thaiDatetimeFc.DateTimeNow()
                    )
                );
              }
            })
            .catch(function(error) {
              ScrObj.output = error;

              ScrObj.show(
                "ansn-foo-css",
                "error",
                "Save Data Error",
                "การลบข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                  "<br>ErrorMessage : " +
                  ScrObj.output +
                  "<br>Date : " +
                  ScrObj.thaiDatetimeFc.ThaiDateTime(
                    ScrObj.thaiDatetimeFc.DateTimeNow()
                  )
              );

              console.log("AdmitDischargeSummaryAction : " + ScrObj.output);
            })
            .finally(function() {
              ScrObj.setData(ScrObj.ptVN, ScrObj.ptHN, ScrObj.ptAN);
            });
        }
      }
    },
    setData(vn, hn, an) {
      if (hn != "" && an != "") {
        let data = [];

        /** Admit Data Load */
        let DataObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitData.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id: val.an,
                  an: val.an,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientAdmitData.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitData.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("AdmitData : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(
              vn,
              hn,
              an,
              "ptAdmit",
              DataObj.$store.get("systems@LoginData").UserId
            );
          });

        /** Admit Diag Data Load */
        let DiagDataObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitDiagData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            DiagDataObj.output = response.data;
            if (DiagDataObj.output.status === true) {
              PatientAdmitDiagData.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DiagDataObj.output.result) {
                data.push({
                  id: val.ipt_diag_id,
                  ipt_diag_id: val.ipt_diag_id,
                  an: val.an,
                  hn: val.hn,
                  diagtype: val.diagtype,
                  datas: val
                });
              }

              PatientAdmitDiagData.insertOrUpdate({
                data
              });
            } else {
              if (DiagDataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitDiagData.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DiagDataObj.output = error;
            console.log("AdmitDiagData : " + DiagDataObj.output);
          })
          .finally(function() {
            DiagDataObj.getData(
              vn,
              hn,
              an,
              "ptAdmitDiag",
              DiagDataObj.$store.get("systems@LoginData").UserId
            );

            DiagDataObj.loadDocumentScanIPD(hn, '', an)

            // $store.set("systems@anLoad", true);
          });

        /** Admit Operation Data Load */
        let OpDataObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitOperationData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            OpDataObj.output = response.data;
            if (OpDataObj.output.status === true) {
              PatientAdmitOperationData.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of OpDataObj.output.result) {
                data.push({
                  id: val.iptoprt_id,
                  iptoprt_id: val.iptoprt_id,
                  an: val.an,
                  hn: val.hn,
                  icd9: val.icd9,
                  datas: val
                });
              }

              PatientAdmitOperationData.insertOrUpdate({
                data
              });
            } else {
              if (OpDataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitOperationData.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            OpDataObj.output = error;
            console.log("AdmitOperationData : " + OpDataObj.output);
          })
          .finally(function() {
            OpDataObj.getData(
              vn,
              hn,
              an,
              "ptAdmitOperation",
              OpDataObj.$store.get("systems@LoginData").UserId
            );
          });

        /** Admit Drug & NoneDrug Load */
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DrugNonDrugData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an,
            order_type: "Hme"
          })
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientDrugNoneDrug.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id: val.hos_guid,
                  hn: val.hn,
                  vn: val.vn,
                  an: val.an,
                  datas: val
                });
              }

              PatientDrugNoneDrug.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientDrugNoneDrug.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("DrugNonDrugData : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(
              vn,
              hn,
              an,
              "ptAdmitHomeMed",
              DataObj.$store.get("systems@LoginData").UserId
            );
          });

        let datas = {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          an: an,
          hn: hn,
          ipt_order_id: "",
          order_no: "",
          order_type: ""
        };

        /** Admit Rx Order Load */
        this.axios
          .post(this.$store.get("systems@UrlApi") + "AdmitOrderNo", datas)
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitRxOrderData.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id: val.ipt_order_id,
                  ipt_order_id: val.ipt_order_id,
                  order_no: val.order_no,
                  an: val.an,
                  hn: val.hn,
                  order_type: val.order_type,
                  rxdate: val.rxdate,
                  rxtime: val.rxtime,
                  datas: val
                });
              }

              PatientAdmitRxOrderData.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitRxOrderData.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("AdmitOrderNo : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(
              vn,
              hn,
              an,
              "ptAdmitRxOrder",
              DataObj.$store.get("systems@LoginData").UserId
            );
          });

        /** Admit Discharge Summary Data */
        this.axios
          .post(
            this.$store.get("systems@UrlApi") + "AdmitDischargeSummaryData",
            {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: hn,
              an: an
            }
          )
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitDischargeSummary.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id:
                    val.an +
                    val.loginname +
                    DataObj.thaiDatetimeFc.DateTimeToIntDateTime(
                      val.discharge_summary_datetime_log
                    ),
                  an: val.an,
                  hn: val.hn,
                  loginname: val.loginname,
                  discharge_summary_status: val.discharge_summary_status,
                  discharge_summary_datetime_log:
                    val.discharge_summary_datetime_log,
                  datas: val
                });
              }

              PatientAdmitDischargeSummary.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitDischargeSummary.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log("AdmitDischargeSummaryData : " + DataObj.output);
          })
          .finally(function() {
            DataObj.getData(
              vn,
              hn,
              an,
              "AdmitDischargeSummary",
              DataObj.$store.get("systems@LoginData").UserId
            );
          });

        /** Admit Discharge Summary Coding Audit Data */
        this.axios
          .post(
            this.$store.get("systems@UrlApi") +
              "AdmitDischargeSummaryCodingAuditData",
            {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: hn,
              an: an
            }
          )
          .then(function(response) {
            DataObj.output = response.data;
            if (DataObj.output.status === true) {
              PatientAdmitDischargeSummaryCodingAudit.delete({
                where(record) {
                  return record.an == an;
                }
              });

              data = [];
              for (var val of DataObj.output.result) {
                data.push({
                  id:
                    val.an +
                    val.loginname +
                    DataObj.thaiDatetimeFc.DateTimeToIntDateTime(
                      val.discharge_summary_datetime_log
                    ),
                  an: val.an,
                  hn: val.hn,
                  loginname: val.loginname,
                  discharge_summary_status: val.discharge_summary_status,
                  discharge_summary_datetime_log:
                    val.discharge_summary_datetime_log,
                  datas: val
                });
              }

              PatientAdmitDischargeSummaryCodingAudit.insertOrUpdate({
                data
              });
            } else {
              if (DataObj.output.ErrorMessage === "Data Not Found") {
                PatientAdmitDischargeSummaryCodingAudit.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            DataObj.output = error;
            console.log(
              "AdmitDischargeSummaryCodingAuditData : " + DataObj.output
            );
          })
          .finally(function() {
            DataObj.getData(
              vn,
              hn,
              an,
              "AdmitDischargeSummaryCodingAudit",
              "CodingAudit"
            );
          });

        let Obj4 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientIpdImage", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            an: an
          })
          .then(function(response) {
            Obj4.output = response.data;
            if (Obj4.output.status === true) {
              PatientIpdImage.delete({
                where(record) {
                  return record.an == an;
                }
              });

              let data = [];
              for (var val of Obj4.output.result) {
                data.push({
                  id: val.file_id,
                  file_id: val.file_id,
                  hn: val.hn,
                  an: val.an,
                  datas: val
                });
              }

              PatientIpdImage.insertOrUpdate({
                data
              });
            } else {
              if (Obj4.output.ErrorMessage === "Data Not Found") {
                PatientIpdImage.delete({
                  where(record) {
                    return record.an == an;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            Obj4.output = error;
            console.log("PatientIpdImage : " + Obj4.output);
          })
          .finally(function() {
            Obj4.getIPDImageList(an, hn);
          });

        this.setIpfsList(an, hn);
      }
    },
    getIPDImageList(an, hn) {
      /** get IPD Image list Data */
      let DataObj = null;
      DataObj = PatientIpdImage.query()
        .where(record => record.hn == hn)
        .where(record => record.an == an)
        .where(record => record.datas.file_status == "Y")
        .get();
      if (DataObj.length > 0) {
        this.IPDImageListData = DataObj;
      } else {
        this.IPDImageListData = [];
      }

      // console.log("sssss", this.IPDImageListData)
    },
    getData(vn, hn, an, act, dchUser) {
      this.SelectdchUser = dchUser;

      let DataObj = null;
      let val = null;

      if (hn != "" && an != "") {
        let LabHeadObj = PatientLabHead.query()
          .where(record => record.datas.hn == hn)
          .where(record => record.datas.an == an)
          .get();

        this.LabHeadCount = LabHeadObj.length;

      }

      if (hn != "" && act == "ptData") {
        DataObj = null;
        DataObj = PatientData.query()
          .where(record => record.id == hn)
          .get();
        if (DataObj.length > 0) {
          this.ptData = DataObj[0];
        } else {
          this.ptData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmit") {
        /** get Admit Data */
        DataObj = null;
        DataObj = PatientAdmitData.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .get();
        if (DataObj.length > 0) {
          this.ptAdmitData = DataObj[0];
        } else {
          this.ptAdmitData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmitDiag") {
        /** get Admit Diag Data */
        DataObj = null;
        DataObj = PatientAdmitDiagData.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .orderBy("diagtype")
          .get();
        if (DataObj.length > 0) {
          this.ptAdmitDiagData = DataObj;
        } else {
          this.ptAdmitDiagData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmitOperation") {
        /** get Admit Operation Data */
        DataObj = null;
        DataObj = PatientAdmitOperationData.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .get();
        if (DataObj.length > 0) {
          this.ptAdmitOperationData = DataObj;
        } else {
          this.ptAdmitOperationData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmitHomeMed") {
        /** get Admit Home Med Data */
        DataObj = null;
        DataObj = PatientDrugNoneDrug.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .where(record => record.datas.order_type == "Hme")
          .get();

        if (DataObj.length > 0) {
          this.ptAdmitHomeMedData = DataObj;
        } else {
          this.ptAdmitHomeMedData = null;
        }
      }

      if (hn != "" && an != "" && act == "ptAdmitRxOrder") {
        /** get Admit Home Med Data */
        DataObj = null;
        DataObj = PatientAdmitRxOrderData.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .orderBy("rxdate", "desc")
          .orderBy("rxtime", "desc")
          .get();

        if (DataObj.length > 0) {
          this.ptAdmitRxOrderData = DataObj;
        } else {
          this.ptAdmitRxOrderData = null;
        }
      }

      if (hn != "" && an != "" && act == "AdmitDischargeSummary") {
        /** get Admit Discharge Summary */
        DataObj = null;
        DataObj = PatientAdmitDischargeSummary.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .where(record => record.discharge_summary_status == "Y")
          .get();

        if (DataObj.length > 0) {
          this.ptAdmitDischargeSummary = DataObj;
        } else {
          this.ptAdmitDischargeSummary = null;
        }

        /** get User Admit Discharge Summary */
        DataObj = null;
        DataObj = PatientAdmitDischargeSummary.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .where(record => record.loginname == dchUser)
          .where(record => record.discharge_summary_status == "Y")
          .get();

        if (DataObj.length > 0) {
          this.UserAdmitDischargeSummary = DataObj[0];
          this.ptAdmitDischargeStatusSelect = DataObj[0].datas.doctor_dchstts;
          this.ptAdmitDischargeTypeSelect = DataObj[0].datas.doctor_dchtype;

          this.primary_diagnosis = DataObj[0].datas.doctor_primary_diagnosis;
          this.comorbidity = DataObj[0].datas.doctor_comorbidity;
          this.complication = DataObj[0].datas.doctor_complication;
          this.others_diag = DataObj[0].datas.doctor_others_diag;
          this.course_progressnote =
            DataObj[0].datas.doctor_course_progressnote;
          this.anesthetic_note = DataObj[0].datas.doctor_anesthetic_note;
          this.operation_procedure =
            DataObj[0].datas.doctor_operation_procedure;
          this.operation_findings = DataObj[0].datas.doctor_operation_findings;
          this.doctor_note = DataObj[0].datas.doctor_note;
          this.dchtype_text = DataObj[0].datas.doctor_dchtype_text;
        } else {
          this.UserAdmitDischargeSummary = null;
          this.ptAdmitDischargeStatusSelect = "";
          this.ptAdmitDischargeTypeSelect = "";

          this.primary_diagnosis = "";
          this.comorbidity = "";
          this.complication = "";
          this.others_diag = "";
          this.course_progressnote = "";
          this.anesthetic_note = "";
          this.operation_procedure = "";
          this.operation_findings = "";
          this.doctor_note = "";
          this.dchtype_text = "";
        }
      }

      if (hn != "" && an != "" && act == "AdmitDischargeSummaryCodingAudit") {
        /** get User Admit Discharge Summary Coding Audit */
        DataObj = null;
        DataObj = PatientAdmitDischargeSummaryCodingAudit.query()
          .where(record => record.hn == hn)
          .where(record => record.an == an)
          .where(record => record.loginname == dchUser)
          .where(record => record.discharge_summary_status == "Y")
          .get();

        if (DataObj.length > 0) {
          this.coding_audit_data_status = true;
          this.CodingAuditUserAdmitDischargeSummary = DataObj[0];
          this.CodingAuditptAdmitDischargeStatusSelect =
            DataObj[0].datas.doctor_dchstts;
          this.CodingAuditptAdmitDischargeTypeSelect =
            DataObj[0].datas.doctor_dchtype;

          this.coding_audit_primary_diagnosis =
            DataObj[0].datas.doctor_primary_diagnosis;
          this.coding_audit_comorbidity = DataObj[0].datas.doctor_comorbidity;
          this.coding_audit_complication = DataObj[0].datas.doctor_complication;
          this.coding_audit_others_diag = DataObj[0].datas.doctor_others_diag;
          this.coding_audit_course_progressnote =
            DataObj[0].datas.doctor_course_progressnote;
          this.coding_audit_anesthetic_note =
            DataObj[0].datas.doctor_anesthetic_note;
          this.coding_audit_operation_procedure =
            DataObj[0].datas.doctor_operation_procedure;
          this.coding_audit_operation_findings =
            DataObj[0].datas.doctor_operation_findings;
          this.coding_audit_doctor_note = DataObj[0].datas.doctor_note;
          this.coding_audit_dchtype_text = DataObj[0].datas.doctor_dchtype_text;
        } else {
          this.coding_audit_data_status = false;

          DataObj = PatientAdmitDischargeSummary.query()
            .where(record => record.hn == hn)
            .where(record => record.an == an)
            .where(record => record.discharge_summary_status == "Y")
            .get();

          if (DataObj.length > 0) {
            let n = 1;
            this.CodingAuditUserAdmitDischargeSummary = DataObj[0];
            for (let val of DataObj) {
              if (n <= 1) {
                this.CodingAuditptAdmitDischargeStatusSelect =
                  val.datas.doctor_dchstts;
                this.CodingAuditptAdmitDischargeTypeSelect =
                  val.datas.doctor_dchtype;

                this.coding_audit_primary_diagnosis =
                  val.datas.doctor_primary_diagnosis;
                this.coding_audit_comorbidity = val.datas.doctor_comorbidity;
                this.coding_audit_complication = val.datas.doctor_complication;
                this.coding_audit_others_diag = val.datas.doctor_others_diag;
                this.coding_audit_course_progressnote =
                  val.datas.doctor_course_progressnote;
                this.coding_audit_anesthetic_note =
                  val.datas.doctor_anesthetic_note;
                this.coding_audit_operation_procedure =
                  val.datas.doctor_operation_procedure;
                this.coding_audit_operation_findings =
                  val.datas.doctor_operation_findings;
                this.coding_audit_doctor_note = val.datas.doctor_note;
                this.coding_audit_dchtype_text = val.datas.doctor_dchtype_text;

                n = n + 1;
              } else {
                if (val.datas.doctor_dchstts != "") {
                  if (this.CodingAuditptAdmitDischargeStatusSelect != "") {
                    this.CodingAuditptAdmitDischargeStatusSelect =
                      this.CodingAuditptAdmitDischargeStatusSelect +
                      "\n" +
                      val.datas.doctor_dchstts;
                  } else {
                    this.CodingAuditptAdmitDischargeStatusSelect =
                      this.CodingAuditptAdmitDischargeStatusSelect +
                      val.datas.doctor_dchstts;
                  }
                }
                if (val.datas.doctor_dchtype != "") {
                  if (this.CodingAuditptAdmitDischargeTypeSelect != "") {
                    this.CodingAuditptAdmitDischargeTypeSelect =
                      this.CodingAuditptAdmitDischargeTypeSelect +
                      "\n" +
                      val.datas.doctor_dchtype;
                  } else {
                    this.CodingAuditptAdmitDischargeTypeSelect =
                      this.CodingAuditptAdmitDischargeTypeSelect +
                      val.datas.doctor_dchtype;
                  }
                }
                if (val.datas.doctor_primary_diagnosis != "") {
                  if (this.coding_audit_primary_diagnosis != "") {
                    this.coding_audit_primary_diagnosis =
                      this.coding_audit_primary_diagnosis +
                      "\n" +
                      val.datas.doctor_primary_diagnosis;
                  } else {
                    this.coding_audit_primary_diagnosis =
                      this.coding_audit_primary_diagnosis +
                      val.datas.doctor_primary_diagnosis;
                  }
                }
                if (val.datas.doctor_comorbidity != "") {
                  if (this.coding_audit_comorbidity != "") {
                    this.coding_audit_comorbidity =
                      this.coding_audit_comorbidity +
                      "\n" +
                      val.datas.doctor_comorbidity;
                  } else {
                    this.coding_audit_comorbidity =
                      this.coding_audit_comorbidity +
                      val.datas.doctor_comorbidity;
                  }
                }
                if (val.datas.doctor_complication != "") {
                  if (this.coding_audit_complication != "") {
                    this.coding_audit_complication =
                      this.coding_audit_complication +
                      "\n" +
                      val.datas.doctor_complication;
                  } else {
                    this.coding_audit_complication =
                      this.coding_audit_complication +
                      val.datas.doctor_complication;
                  }
                }
                if (val.datas.doctor_others_diag != "") {
                  if (this.coding_audit_others_diag != "") {
                    this.coding_audit_others_diag =
                      this.coding_audit_others_diag +
                      "\n" +
                      val.datas.doctor_others_diag;
                  } else {
                    this.coding_audit_others_diag =
                      this.coding_audit_others_diag +
                      val.datas.doctor_others_diag;
                  }
                }

                if (val.datas.doctor_course_progressnote != "") {
                  if (this.coding_audit_course_progressnote != "") {
                    this.coding_audit_course_progressnote =
                      this.coding_audit_course_progressnote +
                      "\n" +
                      val.datas.doctor_course_progressnote;
                  } else {
                    this.coding_audit_course_progressnote =
                      this.coding_audit_course_progressnote +
                      val.datas.doctor_course_progressnote;
                  }
                }
                if (val.datas.doctor_anesthetic_note != "") {
                  if (this.coding_audit_anesthetic_note != "") {
                    this.coding_audit_anesthetic_note =
                      this.coding_audit_anesthetic_note +
                      "\n" +
                      val.datas.doctor_anesthetic_note;
                  } else {
                    this.coding_audit_anesthetic_note =
                      this.coding_audit_anesthetic_note +
                      val.datas.doctor_anesthetic_note;
                  }
                }
                if (val.datas.doctor_operation_procedure != "") {
                  if (this.coding_audit_operation_procedure != "") {
                    this.coding_audit_operation_procedure =
                      this.coding_audit_operation_procedure +
                      "\n" +
                      val.datas.doctor_operation_procedure;
                  } else {
                    this.coding_audit_operation_procedure =
                      this.coding_audit_operation_procedure +
                      val.datas.doctor_operation_procedure;
                  }
                }
                if (val.datas.doctor_operation_findings != "") {
                  if (this.coding_audit_operation_findings != "") {
                    this.coding_audit_operation_findings =
                      this.coding_audit_operation_findings +
                      "\n" +
                      val.datas.doctor_operation_findings;
                  } else {
                    this.coding_audit_operation_findings =
                      this.coding_audit_operation_findings +
                      val.datas.doctor_operation_findings;
                  }
                }
                if (
                  val.datas.doctor_note != "" &&
                  val.datas.doctor_note != null
                ) {
                  if (this.coding_audit_doctor_note != "") {
                    this.coding_audit_doctor_note =
                      this.coding_audit_doctor_note +
                      "\n" +
                      val.datas.doctor_note;
                  } else {
                    this.coding_audit_doctor_note =
                      this.coding_audit_doctor_note + val.datas.doctor_note;
                  }
                }
                if (val.datas.doctor_dchtype_text != "") {
                  if (this.coding_audit_dchtype_text != "") {
                    this.coding_audit_dchtype_text =
                      this.coding_audit_dchtype_text +
                      "\n" +
                      val.datas.doctor_dchtype_text;
                  } else {
                    this.coding_audit_dchtype_text =
                      this.coding_audit_dchtype_text +
                      val.datas.doctor_dchtype_text;
                  }
                }
              }
            }
          } else {
            this.CodingAuditUserAdmitDischargeSummary = null;
            this.CodingAuditptAdmitDischargeStatusSelect = "";
            this.CodingAuditptAdmitDischargeTypeSelect = "";
            this.coding_audit_primary_diagnosis = "";
            this.coding_audit_comorbidity = "";
            this.coding_audit_complication = "";
            this.coding_audit_others_diag = "";
            this.coding_audit_course_progressnote = "";
            this.coding_audit_anesthetic_note = "";
            this.coding_audit_operation_procedure = "";
            this.coding_audit_operation_findings = "";
            this.coding_audit_doctor_note = "";
            this.coding_audit_dchtype_text = "";
          }
        }
      }

      if (hn != "" && an != "" && act == "AdmitDischargeType") {
        /** get Admit Discharge Type */
        DataObj = null;
        DataObj = PatientAdmitDischargeType.query()
          .where(record => record.id != "")
          .get();

        if (DataObj.length > 0) {
          let data1 = [];
          data1.push({
            value: "",
            text: ".:: Discharge Type ::."
          });

          for (val of DataObj) {
            data1.push({
              value: val.id,
              text: val.datas.name
            });
          }

          this.ptAdmitDischargeType = data1;
        } else {
          this.ptAdmitDischargeType = null;
        }
      }

      if (hn != "" && an != "" && act == "AdmitDischargeStatus") {
        /** get Admit Discharge Type */
        DataObj = null;
        DataObj = PatientAdmitDischargeStatus.query()
          .where(record => record.id != "")
          .get();

        if (DataObj.length > 0) {
          let data2 = [];
          data2.push({
            value: "",
            text: ".:: Discharge Status ::."
          });

          for (val of DataObj) {
            data2.push({
              value: val.id,
              text: val.datas.name
            });
          }

          this.ptAdmitDischargeStatus = data2;
        } else {
          this.ptAdmitDischargeStatus = null;
        }
      }

      // console.log(this.ptAdmitData)
    },
    getRxOrderDetailData(vn, hn, an, order_no) {
      /** get Admit Rx Order Data */
      let DataObj = null;
      DataObj = PatientDrugNoneDrug.query()
        .where(record => record.hn == hn)
        .where(record => record.an == an)
        .where(record => record.datas.order_no == order_no)
        .get();

      if (DataObj.length > 0) {
        return DataObj;
      } else {
        return null;
      }
    },

    TextToHtml(txt) {
      if (txt != null && txt != "") {
        String.prototype.replaceAll = function(search, replacement) {
          var target = this;
          return target.split(search).join(replacement);
        };
        let PgNote = txt;
        PgNote = PgNote.replaceAll("\n", "<br>");

        return PgNote;
      } else {
        return "";
      }
    },
    closeDischargeSummary(userDCH) {
      this.$root.$emit(
        "bv::toggle::collapse",
        "modal-admit-discharge-summary-ed-" + userDCH
      );
    },
    closeDischargeSummaryCodingAudit(userDCH) {
      this.$root.$emit(
        "bv::toggle::collapse",
        "modal-admit-discharge-summary-coding-audit-ed-" + userDCH
      );
    }
  }
})
export default class EmrAdmitData extends Vue {}
</script>

<style lang="scss">
.emr-ipd-operative-note {
  display: none;
}
</style>

